import React, { ChangeEvent } from 'react';
import './viewsensor.css';
import {Contractor, SensorBox, sensors} from '../../interface'
import Select from '../../components/select';
import UserModal from '../createuser'
import Checkbox from '../../components/checkbox'
import ExternalSensorConfig from '../../components/externalSensorConfig'
import userService from '../../services/userService';
import toast from '../toast';
import validate from '../../helpers/validation';
import LoadingWheel from '../loadingwheel';
import constants from '../../config/constants';
import roleService from '../../services/roleService';
import Utility from '../../helpers/Utility';
import ConfirmModal from '../confirmmodal'
import sensorService from '../../services/sensorService';
import authStore from '../../store/authStore';
import userStore from '../../store/userStore';
import trashRestore from '../../assets/trash-restore.svg'
import MaintenanceCheckList from '../maintenance-checklist';
import eventStore from '../../store/eventStore';
import pinConfigurationService from '../../services/pinConfigurationService';
import InspectionChecklistServices from '../../services/InspectionChecklistServices';
import _ from 'lodash';
import MoveSensorboxModal from '../../components/moveSensorboxModal'
import  Permissions from '../../config/permssions'
import SaveConfirmationModal from '../../components/confirmDialogModal';
import DeploymentStatus from '../deploymentStatus';
import DocumentsPanel from '../documentsPanel';
import sensorboxDocumentationService from '../../services/sensorboxDocumentationService';
import issueTrackerServices from '../../services/issueTrackerServices';
import assetMaintenanceNotesService from '../../services/assetMaintenanceNotesService';
import DatePicker from '../datepicker';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Modal as AntModal, Tooltip } from 'antd';
import moment from 'moment';
import Routes from '../../routing/routes';
import AlertRecipientsCard from '../AlertRecipientsCard';
import { mergeTeamRecipients, splitTeamRecipients, AlertRecipient } from '../../utils/alertRecipients';

const {
    super_admin_access,
    org_admin_access ,
    view_contractor_sensorboxes_assets,
    view_assigned_users_sensorboxes_assets,
    create_or_update_sensorboxes_assets,
    delete_sensorboxes_assets,
    view_only_partial_asset_sensorbox_details,
    view_all_issue_tracker
  } = Permissions

const categoryOptions = [
    { _id: 'default', name: 'Default' },
    { _id: 'chiller-smaller', name: 'Small Chiller' },
    { _id: 'chiller-larger', name: 'Large Chiller' },
    { _id: 'chromalox', name: 'Chromalox' },
    { _id: 'fieldtest', name: 'Field Test' },
    { _id: 'generator', name: 'Generator' },
]

const boardVersionOptions = [
    { _id: 3, name: 'Rev3' },
    { _id: 6, name: 'Rev6' },
    { _id: 7, name: 'Rev7' }
]

const deviceTypeOptions = [
    { _id: 'general', name: 'General' },
    { _id: 'lockrouter', name: 'Lock Rotor' },
    { _id: 'cyclictest', name: 'Cyclic Test' }
]

const sensorBoxSourceOptions = [
    { _id: 'internal', name: 'Internal' },
    { _id: 'external', name: 'External' }
]

const sensorBoxTypeOptions = [
    { _id: 'monnit', name: 'Ext - MON' },
    { _id: 'lgmv', name: 'Ext - LGMV' },
    { _id: 'bas', name: 'Ext - BAS' }
]

export interface createSensorBoxFormProps {
    sensorbox?                  :   SensorBox;
    clearSelectedSensorBox      :   any;
    updateSensorBoxList         :   any;
    organisationId?             :   any;
    organisationList?           :   any;
    shouldPageChange            :   any;
    setVisibleClose?            :   any;
    updateEventSourceListener   :   () => void;
    issueDetailsParams          : any
}

export interface createSensorBoxFormState {
    sensorbox?      :   SensorBox;
    error?          :   SensorBox;
    isEdit          :   boolean;
    user_access      :   Array<any>;
    roleList        :   Array<any>;
    consumerList    :   Array<object>;
    inspectionList  :   Array<object>;
    contractorList  :   Array<object>;
    coordinates     :   Array<object>;
    isLoading       :   boolean;
    sensorTypeList  :   Array<any>;
    sensorTemplates?   :   Array<any>;
    sensorTypeListCopy  :   Array<object>;
    sensors         :   Array<object>;
    sensorDetails?  :   sensors;
    responseError   :   string;
    refrigerantList :   Array<object>;
    tabactive       :   boolean;
    tabhomeactive   :   boolean;
    timeZoneList    :   Array<any>,
    validRangeError? :  string;
    validCalibrationError? :  string;
    invalidDeploymentStatusDate? : boolean;
    activeTab       :   string;
    pinConfigList   :   any;
    pinError        :   any;
    showMoveSensorboxModal : boolean;
    saveConfirmationModal: boolean;
    saveType: string;
    readIntervalChanged: boolean;
    issueCount: number;
    maintenanceNotes: Array<any>;
    maintenanceNotesLoading: boolean;
    editingNoteId: string | null;
    newNote: { notes: string; status: string; created_on: Date | null };
    editingNote: { notes: string; status: string; created_on: Date | null };
    issues: Array<any>;
    issuesLoading: boolean;
}



class CreateSensorBox extends React.Component<createSensorBoxFormProps, createSensorBoxFormState> {
    sensorArray : any = []    
    defaultRole: { _id: string; name: string; };
    issueDetailsParams: { pageNumber: number; limit: number; orgId: string; status: string[]; consumer: any[]; contractor: any[]; service_resolved_by: any[]; searchFilter: string; startDate: string; endDate: string; groupId: string};
    constructor(props : createSensorBoxFormProps){
        super(props)
        this.defaultRole={ _id : '',name : 'All Roles'};
        this.state = {
            sensorbox           :   undefined,
            error               :   undefined,
            isEdit              :   false,
            roleList            :   [this.defaultRole],
            consumerList        :   [],
            user_access          :   [],
            inspectionList      :   [],
            contractorList      :   [],
            coordinates         :   [],
            isLoading           :   false,
            sensorTypeList      :   [],
            sensorTypeListCopy  :   [],
            sensorTemplates       :   [],
            sensors             :   [],
            sensorDetails       :   undefined,
            responseError       :   '',
            refrigerantList     :   [],
            tabactive           :   false,
            tabhomeactive       :   true,
            timeZoneList        :   [],  
            validRangeError     :   '',
            validCalibrationError : '',
            invalidDeploymentStatusDate : false,
            activeTab           :   'sensorbox',
            pinConfigList       :   {},
            pinError            :   {},
            showMoveSensorboxModal : false,
            saveConfirmationModal : false,
            saveType: '',
            readIntervalChanged: false,
            issueCount: 0,
            maintenanceNotes: [],
            maintenanceNotesLoading: false,
            editingNoteId: null,
            newNote: { notes: '', status: 'OPEN', created_on: new Date() },
            editingNote: { notes: '', status: 'OPEN', created_on: null },
            issues: [],
            issuesLoading: false
        }
        this.issueDetailsParams = {
            pageNumber: 1, 
            limit: 10, 
            orgId: '', 
            status: ['OPEN'], 
            consumer: [], 
            contractor: [], 
            service_resolved_by: [], 
            searchFilter: '', 
            startDate: '', 
            endDate: '',
            groupId: '',
        }
    }

    componentDidMount() {
        const { sensorbox } : any = this.state
        this.setState({ isLoading: true })
        if (this.props.sensorbox) {
            let category = categoryOptions.find((value:any)=>(value._id === this.props.sensorbox?.category))  
            const sensorBoxSource = this.props.sensorbox?.sensor_box_source || 'internal'
            this.setState({ sensorbox: {...JSON.parse(JSON.stringify(this.props.sensorbox)) ,category : category, board_version : this.props.sensorbox?.board_version, sensor_box_source: sensorBoxSource}}, async () => {
                if(this.props?.sensorbox?.consumer?.[0]?._id){ // get inspection details
                    let inspection_data = await InspectionChecklistServices.getInspectionsList({ customer : this.props?.sensorbox?.consumer?.[0]?._id , orgid : this.props?.organisationId});
                    const inspectionList = inspection_data?.data?.inspections?.map((inspection: any) => {
                        let address = (inspection?.consumer_data?.street && inspection?.consumer_data?.city && inspection?.consumer_data?.state) ?   `${inspection?.consumer_data?.street}, ${inspection?.consumer_data?.city}, ${inspection?.consumer_data?.state} ` : '-'
                        let inspections: any = { _id: inspection?._id, name: `${inspection?.system_name} / ${address}` };
                        return inspections
                    })
                    this.setState({inspectionList})
                }

                this.sensorArray = this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors : [];
                await this.getRoles()
                await this.getCustomerList()

                let userAccessArray = this.state?.consumerList?.filter((item:any)=>(
                        this.props.sensorbox?.user_access?.includes(item?._id)
                ))  
                    
                let userAccessObject = userAccessArray?.map((item:any)=>({value:item._id,label:item.name})) 

                this.setState({ sensorbox: {...JSON.parse(JSON.stringify(this.props.sensorbox)) , userAccessObject ,category : category, board_version : this.props.sensorbox?.board_version}})
                await this.getContractorList()
                await this.getPinConfiguration();
                await this.getSensorTypeList()
                await this.getSensorTemplates()
                await this.getRefrigerentList()
                await this.getIssueTrackerList(this.props.sensorbox)
                this.setState({ isLoading: false })
            })
        } else {
            let category = categoryOptions.find((value:any)=>(value._id === 'default')) 
            const sensorBoxSource = this.props.sensorbox?.sensor_box_source || 'internal'
            this.setState({ sensorbox: { ...sensorbox , heat_provided_by : 'furnace' ,category  ,board_version : 3 , offline_alert_on : true, device_type : 'general', sensor_box_source: sensorBoxSource} }, async () => {
                await this.getRoles()
                await this.getCustomerList()
                await this.getContractorList()
                await this.getSensorTypeList()
                await this.getSensorTemplates()
                await this.getPinConfiguration()
                await this.getRefrigerentList()
                this.getNewSensorBoxName()
                this.setState({ isLoading: false })
            })
        }
    }

    isDisabled() {
        return (this.state.sensorbox !== undefined && this.state.sensorbox._id !== undefined && !this.state.isEdit) || this.state.isLoading 
    }

    // this is temporary solution for identifying HVAC Intel organization
    isDisabledSensorBoxId() {
        if ((this.state.sensorbox !== undefined && this.state.sensorbox._id !== undefined) || this.state.isLoading || !authStore.currentUser.is_default || this.props?.organisationId)
            return authStore?.currentUser?.oid === this.props?.organisationId ? this.isUpdate() ? !this.state.isEdit : false : true;
        return false

    }

    isGrouped() {
        const { sensorbox } = this.props;
        return !(sensorbox?.sensorbox_group === null || sensorbox?.sensorbox_group === undefined)
    }

    isUpdate(){
        return this.state.sensorbox !== undefined && this.state.sensorbox._id !== undefined 
    }

    getRoles :any = async () => {
        try {
            const response = await roleService.getRoles(authStore.currentUser.oid ? authStore.currentUser.oid  : this.props?.organisationId)
            let filteredValue = response.data.roles.filter((item :any)=> item.role_hierarchy > authStore.currentUser.role_hierarchy)
            let orgFilteredValue = response.data.roles.filter((item :any)=> item.role_hierarchy >= authStore.currentUser.role_hierarchy)                

            if(authStore?.isOrgAdmin()){
                this.setState({roleList : [this.defaultRole, ...orgFilteredValue] , isLoading : false})
            }
            else{
                this.setState({roleList : [this.defaultRole, ...filteredValue] , isLoading : false})
            }

        } catch (error) {
                toast.error(error.response.data.message)
                this.setState({isLoading : false})
        }
    }

    sensorBoxExist = async() =>{      
        let error               =   {} as any
        let isValid             =   false
        if(this.state.sensorbox && this.state.sensorbox.sensor_box_name){
            try{
                let response = await sensorService.checkSensorBoxExist(this.state.sensorbox._id,this.state.sensorbox.sensor_box_name)
                if(response !== 0){
                    error.sensor_box_name   =  constants.message.name_exist
                    isValid                 =  true
                    this.setState({error});
                    return isValid 
                }else{
                    error.sensor_box_name   = ''
                    this.setState({error});
                    return isValid 
                }                
            }catch(error){
                toast.error(error.response.data.message)
            }              
        }else{   
            return isValid 
        }
    }

    updateTextFieldValue(e : any,type?:string) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        let error  = {} as any;
        Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
        this.setState({sensorbox : this.state.sensorbox,error})
                     
    }

    updateSystemName(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        if(validate.isValidSystemName(e.target.value)){
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
            this.setState({sensorbox : this.state.sensorbox,error})
        }                
             
    }

    updateAlias(e:any) {
        
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
        this.setState({sensorbox : this.state.sensorbox})
             
    }
    updateReadInterval(e: any) {
        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} })
        }
        const read_interval = parseInt(e.target.value.trim())
        if (!_.isNaN(read_interval)) {
            let readIntervalChanged = this.state.sensorbox?.read_interval !== read_interval
            Object.assign(this.state.sensorbox, { read_interval })
            this.setState({ sensorbox: this.state.sensorbox, readIntervalChanged })
        } else {
            Object.assign(this.state.sensorbox, { read_interval: '' })
            this.setState({ sensorbox: this.state.sensorbox, readIntervalChanged: false })
        }

    }

    updateAddressValue(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }        
        // if(validate.isValidAddress(e.target.value)){
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
            this.setState({sensorbox : this.state.sensorbox,error})
        // } 
               
             
    }

    updateCapacityValue(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        if(validate.isValidValue(e.target.value)){
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
            this.setState({sensorbox : this.state.sensorbox,error});
        } 
                
             
    }

    updateModelValue(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }         
        if(validate.isValidModel(e.target.value)){
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
            this.setState({sensorbox : this.state.sensorbox,error})
        }   
             
    }

    updateAirflowValue(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }   
        if(validate.isValidAirflow(e.target.value)){
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{[e.target.name] : e.target.value.trimLeft() })
            this.setState({sensorbox : this.state.sensorbox,error})
        }         
    }

    updateLatitude(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }    
        if(validate.isValidValue(e.target.value)){
            let error  = {} as any;
            let locationArray =  this.state.sensorbox &&  this.state.sensorbox.location &&  this.state.sensorbox.location.coordinates ? this.state.sensorbox.location.coordinates : [];
            locationArray[0]  =   e.target.value;   
            Object.assign(this.state.sensorbox,{ location : {coordinates : locationArray}})  
            this.setState({sensorbox : this.state.sensorbox,error})  
        } else{
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{ location : {coordinates : {}}})  
            this.setState({sensorbox : this.state.sensorbox,error})
        }   
    }

    updateLongitude(e:any) {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }  
        if(validate.isValidValue(e.target.value)){
            let error  = {} as any;
            let locationArray =  this.state.sensorbox &&  this.state.sensorbox.location && this.state.sensorbox.location.coordinates ? this.state.sensorbox.location.coordinates : [];
            locationArray[1]  =   e.target.value;        
            Object.assign(this.state.sensorbox,{ location : {coordinates : locationArray}})
            this.setState({sensorbox : this.state.sensorbox,error})  
        } else{
            let error  = {} as any;
            Object.assign(this.state.sensorbox,{ location : {coordinates : {}}})  
            this.setState({sensorbox : this.state.sensorbox,error})  
        } 
            
    }

    coordinates = async() => {
        let isValid = false;
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        if(this.state.sensorbox && this.state.sensorbox.place){
            isValid = await this.getCoordinates(this.state.sensorbox.place)
        }else{
            isValid = false;
            Object.assign(this.state.sensorbox,{ location :{ coordinates : []}, timezone : ''})  
            this.setState({sensorbox : this.state.sensorbox}) 
        }        
        return isValid;
    }

    async getCoordinates(place :any) {
        let coordinates=[];
        try {
            let error               =   {
                place:''
            } as any
            coordinates         = await userService.getCoordinatesList(place)
           this.getTimeZone(coordinates)
            error.place           = coordinates.length?"":constants.message.address_valid
            if(coordinates){
                let weatherStation = await userService.getWeatherInformation(coordinates)
                Object.assign(this.state.sensorbox,{weather_station : weatherStation?.station_id , forecast_link : weatherStation?.forecast_link , grid_id : weatherStation?.grid_id , grid_x : weatherStation?.grid_x , grid_y : weatherStation?.grid_y}) 
            }
            Object.assign(this.state.sensorbox,{ location :{ coordinates : coordinates}})
            this.setState({sensorbox : this.state.sensorbox,error}); 
            return coordinates.length>0 
        } catch (error) {
            toast.error(error.response.data.message)
            return coordinates.length>0 
        }
    }

    async getTimeZone(coordinates : Array<any>){
        if(coordinates && coordinates.length > 0){
            let timeZone = await userService.getTimeZone(coordinates)
            if(timeZone){
                let sensorbox  = this.state.sensorbox || {} as SensorBox
                sensorbox.timezone = timeZone
                this.setState({sensorbox})
            }
        }
    }
    setTimeZone(value : any){
        let timezone = value.name
        if(validate.validTimeZone(timezone)){
            if(!this.state.sensorbox){
                Object.assign(this.state, {sensorbox : {}})
            }

            Object.assign(this.state.sensorbox, { timezone : timezone })
            this.setState({sensorbox : this.state.sensorbox})
        }
    }

    showUserCreateForm() {
        Utility.showModal('createuser')
        Utility.closeModal('sensorboxdetails')
    }

    updateRefrigerant  = (refrigerent : any)=> {

        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        Object.assign(this.state.sensorbox, { refrigerent : refrigerent })
        this.setState({sensorbox : this.state.sensorbox},()=>{
            this.getRefrigerentList()
        })
    }

    updateCategory  = (category : any)=> {

        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        Object.assign(this.state.sensorbox, { category : category })
        this.setState({sensorbox : this.state.sensorbox})
    }

    inspectionValue(){
        const inspection = this.state?.inspectionList.find((s: any) => s?._id === this.state.sensorbox?.inspection) as any;
        return inspection
    }

    updateBoardVersion = async (boardVersion : any) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        Object.assign(this.state.sensorbox, { board_version : boardVersion?._id })

        let sortedPinsBasedOnBoardVersions = this.state?.sensorTypeList.map((item: any, index: any) => {
            let pin_order = item.pin_order.find((pin: any) => {
                return pin.board_version === boardVersion?._id
            })
            return pin_order ? {...item, pinOrder: pin_order?.order} : item 
        }).sort((a: any, b: any) => (a?.pinOrder - b?.pinOrder))

        await this.sensorType(sortedPinsBasedOnBoardVersions)
        await this.updateDefaultCalibration(this.sensorArray)
        this.setState({sensorbox : this.state.sensorbox})
    }

    updateDeviceType = async (type : any) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        Object.assign(this.state.sensorbox, { device_type : type?._id })
        this.setState({sensorbox : this.state.sensorbox})
    }

    updateSensorBoxSource = async (value : any) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        const source = value?._id || 'internal'
        Object.assign(this.state.sensorbox, { sensor_box_source : source })
        
        // Clear sensors when switching sources
        this.sensorArray = []
        Object.assign(this.state.sensorbox, { sensors: [] })
        
        // Refresh pin configurations and sensor types for the new source
        await this.getPinConfiguration()
        await this.getSensorTypeList()
        await this.getSensorTemplates()
        
        this.setState({sensorbox : this.state.sensorbox})
    }


    updateSensorBoxType = async (value : any) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { sensor_box_type : value?._id })
        
        // Clear sensors when switching types
        this.sensorArray = []
        Object.assign(this.state.sensorbox, { sensors: [] })
        
        // Refresh pin configurations and sensor types for the new type
        await this.getPinConfiguration()
        await this.getSensorTypeList()
        await this.getSensorTemplates()
        
        this.setState({sensorbox : this.state.sensorbox})
    }

    updateSourceId = (event: ChangeEvent<HTMLInputElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { source_id : event.target.value })
        this.setState({sensorbox : this.state.sensorbox})
    }

    // updateSourceType = async (event: ChangeEvent<HTMLInputElement>) => {
    //     if(!this.state.sensorbox){
    //         Object.assign(this.state, {sensorbox : {}})
    //     }
    //     Object.assign(this.state.sensorbox, { source_type : event.target.value })
        
    //     // Clear sensors when changing source type
    //     this.sensorArray = []
    //     Object.assign(this.state.sensorbox, { sensors: [] })
        
    //     // Refresh pin configurations and sensor types for the new source type
    //     await this.getPinConfiguration()
    //     await this.getSensorTypeList()
    //     await this.getSensorTemplates()
        
    //     this.setState({sensorbox : this.state.sensorbox})
    // }

    async updateDefaultCalibration (sensors : any){
        if(sensors){
            sensors?.forEach((sensor: any) => {
                if(sensor.sensor_type?.is_configurable?.includes(1)){
                    if(!(sensor.calibration_c !== undefined)){
                        sensor.calibration_c = 1
                        sensor.sensor_type.calibration_c = 1
                    }
                    if(!(sensor.calibration_d !== undefined)){
                        sensor.calibration_d = 0
                        sensor.sensor_type.calibration_d = 0
                    }
                    if(!(sensor.calibration_a !== undefined)){
                        sensor.calibration_a = 0
                        sensor.sensor_type.calibration_a = 0
                    }
                    if(!(sensor.calibration_b !== undefined)){
                        sensor.calibration_b = 0
                        sensor.sensor_type.calibration_b = 0
                    }
                }
            })
        Object.assign(this.state.sensorbox, { sensors })
        }
    }

    updateEmailCustomer = async (data : any) => {
        const consumer = this.convertDropdownData(data,'r')
        let inspectionList = [];

        if(consumer[0]){ // get inspection details
            const inspectionsListFromApi = await InspectionChecklistServices.getInspectionsList({ customer : consumer[0]?._id , orgid : this.props?.organisationId});

            inspectionList = inspectionsListFromApi?.data?.inspections?.map((inspection: any) => {
                let address = (inspection?.consumer_data?.street && inspection?.consumer_data?.city && inspection?.consumer_data?.state) ?   `${inspection?.consumer_data?.street}, ${inspection?.consumer_data?.city}, ${inspection?.consumer_data?.state} ` : '-'
                let inspections: any = { _id: inspection?._id, name: `${inspection?.system_name} / ${address}` };
                return inspections
            })
        }

        this.setState({inspectionList});

        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { consumer : consumer , inspection : ''})
        this.setState({sensorbox : this.state.sensorbox},()=>{
            this.getCustomerList()
        })
    }

    updateMobileCustomer = async (data : any) => {
        const consumer = this.convertDropdownData(data,'r')
        let inspectionList = [];

        if(consumer[0]){ // get inspection details
            const inspectionsListFromApi = await InspectionChecklistServices.getInspectionsList({ customer : consumer[0]?._id , orgid : this.props?.organisationId});

            inspectionList = inspectionsListFromApi?.data?.inspections?.map((inspection: any) => {
                let address = (inspection?.consumer_data?.street && inspection?.consumer_data?.city && inspection?.consumer_data?.state) ?   `${inspection?.consumer_data?.street}, ${inspection?.consumer_data?.city}, ${inspection?.consumer_data?.state} ` : '-'
                let inspections: any = { _id: inspection?._id, name: `${inspection?.system_name} / ${address}` };
                return inspections
            })
        }

        this.setState({inspectionList});

        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { mobile_consumer : consumer , inspection : ''})
        this.setState({sensorbox : this.state.sensorbox},()=>{
            this.getCustomerList()
        })
    }

    updateInspection = async(inspectionData : any) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        Object.assign(this.state.sensorbox, { inspection : inspectionData?._id })
        this.setState({sensorbox : this.state.sensorbox})
    }

    updateFields = (event: ChangeEvent<HTMLInputElement>) => {
        const { sensorbox }: any = this.state
        const { value, name } = event.target;
        let error  = {} as any;
        this.setState({ sensorbox: { ...sensorbox, [name]: value },error})
    }

    updateContractorAlert = (event: ChangeEvent<HTMLInputElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { contractor_alert_on : event.target.checked })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateConsumerAlert = (event: ChangeEvent<HTMLInputElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { consumer_alert_on : event.target.checked })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateOfflineAlert = (event: ChangeEvent<HTMLInputElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { offline_alert_on : event.target.checked })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateOfflineCheckDuration = (event: ChangeEvent<HTMLInputElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        const raw = event.target.value.trim()
        const error = { ...(this.state.error || {}), offline_check_duration: '' } as any
        if (raw === '') {
            Object.assign(this.state.sensorbox, { offline_check_duration: null })
            this.setState({ sensorbox: this.state.sensorbox, error })
            return
        }
        const value = parseInt(raw, 10)
        if (_.isNaN(value) || value < 1) {
            if (!_.isNaN(value)) {
                Object.assign(this.state.sensorbox, { offline_check_duration: value })
            }
            error.offline_check_duration = 'Offline check duration should not be less than 1 minute'
            this.setState({ sensorbox: this.state.sensorbox, error })
            return
        }
        Object.assign(this.state.sensorbox, { offline_check_duration: value })
        this.setState({ sensorbox: this.state.sensorbox, error })
    }


    updateFilterWidth = (event: ChangeEvent<HTMLInputElement>) => {
        if(!event.target.validity.valid) {
            return
        }
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        let value = event.target.value;
        Object.assign(this.state.sensorbox, { filter_width : value })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateFilterLength = (event: ChangeEvent<HTMLInputElement>) => {
        if(!event.target.validity.valid) {
            return
        }
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        let value = event.target.value;
        Object.assign(this.state.sensorbox, { filter_length : value })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateFilterThickness = (event: ChangeEvent<HTMLInputElement>) => {
        if(!event.target.validity.valid) {
            return
        }
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        let value = event.target.value;
        Object.assign(this.state.sensorbox, { filter_thickness : value })
        this.setState({sensorbox: this.state.sensorbox})
    }

    updateFilterQuantity = (event: ChangeEvent<HTMLSelectElement>) => {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        let value = event.target.value;
        Object.assign(this.state.sensorbox, { filter_quantity : value })
        this.setState({sensorbox: this.state.sensorbox})
    }

    validateFilterSize = (fieldName: string, value: number) => {
        if(value !== 0) return;
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }
        Object.assign(this.state.sensorbox, { [fieldName] : '' })
        this.setState({sensorbox: this.state.sensorbox})
    }

    getConsumerAddress = async(consumer:any)  =>{ 

        try{ 
            if(consumer){
                let consumerAddress = await userService.getCustomerAddressDetails(consumer._id)
                if(consumerAddress) {
                    let coordinates     = consumerAddress.location && consumerAddress.location.coordinates;
                    this.getTimeZone(coordinates)
                    let address         = `${consumerAddress?.street}, ${consumerAddress?.city}, ${consumerAddress?.state}, ${consumerAddress?.country}, ${consumerAddress?.zip_code}`;
                    if(coordinates){
                        let weatherStation = await userService.getWeatherInformation(coordinates)
                        Object.assign(this.state.sensorbox,{ place:address ,location :{ coordinates : coordinates} ,weather_station : weatherStation?.station_id , forecast_link : weatherStation?.forecast_link , grid_id : weatherStation?.grid_id , grid_x : weatherStation?.grid_x , grid_y : weatherStation?.grid_y}) 
                    }
                    else{
                        Object.assign(this.state.sensorbox,{ place : '',location :{ coordinates : []}, timezone : '' ,weather_station : '' , forecast_link : '' , grid_id : '' , grid_x : '' , grid_y : '' })
                    }
                }
                this.setState({sensorbox : this.state.sensorbox}); 
            }else{
                Object.assign(this.state.sensorbox,{ place : '',location :{ coordinates : []}, timezone : '' ,weather_station : '' , forecast_link : '' , grid_id : '' , grid_x : '' , grid_y : '' })
            } 
        }catch(error){
            toast.error(error.response.data?.message)
        } 
        
    }

    getCustomerList = async()  =>{     
        try{
            let consumerList = await userService.getCustomerList(this.props?.organisationId)
            if(!this.state.sensorbox){
                Object.assign(this.state, {sensorbox : {}})
            }    
            if(authStore?.currentUser?.active_role?.role_type === -1) {
                consumerList = consumerList.map((item: any, index :any) => ({...item, name: `Consumer ${index+1}`}))
            }

            this.setState({consumerList});
        }catch(error){
            toast.error(error.response.data.message)
        }       
        
    }

    async getRefrigerentList() {     
        try{
            let refrigerantList = await userService.getRefrigerentList();
            if(!this.state.sensorbox){
                Object.assign(this.state, {sensorbox : {}})
            }      
            this.setState({refrigerantList});
        }catch(error){
            toast.error(error.response.data.message)
        }       
        
    }

    async getIssueTrackerList(sensorboxDetails: any) {     
        try{
            this.issueDetailsParams = {pageNumber: 1, limit: 10, orgId: '', status: ['OPEN', 'PENDING REVIEW'], consumer: [], contractor: [], service_resolved_by: [], searchFilter: '', startDate: '', endDate: '', groupId: '', }
            const issueListExist = await issueTrackerServices.getIssueTrackerDetails(this.issueDetailsParams.pageNumber, this.issueDetailsParams.limit, sensorboxDetails?.org_id, this.issueDetailsParams.status, this.issueDetailsParams.consumer, this.issueDetailsParams.contractor, this.issueDetailsParams.service_resolved_by, this.issueDetailsParams.searchFilter, this.issueDetailsParams.startDate, this.issueDetailsParams.endDate , this.issueDetailsParams?.groupId, sensorboxDetails?._id)
            this.setState({issueCount: issueListExist?.count});
        } catch(error){
            console.log(error)
        }       
        
    }


    deleteSensorbox = async(HardDelete : boolean) => {
        try{
            if(this.state.sensorbox){
                if(HardDelete){
                    await  userService.hardDeleteSensorBox(this.state.sensorbox._id)
                }else{
                    await  userService.deleteSensorBox(this.state.sensorbox._id)    
                }    
                this.setState({isLoading : true})
                this.setState({isLoading : false},()=>{
                    this.closeForm()
                    let currentPage = this.props.shouldPageChange(false)
                    this.props.updateSensorBoxList(currentPage)
                })     
            }
        }catch(error){
            this.setState({isLoading : false})
            toast.error(error.response.data.message)
        }
    }

    enableSensorbox = async() =>{

        try{
            if(this.state.sensorbox){
                this.setState({isLoading : true})
                await  sensorService.enableSensorBox(this.state.sensorbox._id)
                this.setState({isLoading : false},()=>{
                        this.closeForm()
                        this.props.updateSensorBoxList()
                })                
            }

        }catch(error){
            toast.error(error.response.data.message)
        }
    }

    updateContractorRecipients = (recipients: AlertRecipient[]) => {
        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} });
        }
        const split = splitTeamRecipients(recipients);
        Object.assign(this.state.sensorbox, {
            contractor: split.email,
            mobile_contractor: split.sms,
            voice_contractor: split.voice,
        });
        this.setState({ sensorbox: this.state.sensorbox }, () => {
            this.getContractorList();
        });
    }

    updateConsumerRecipients = async (recipients: AlertRecipient[]) => {
        const split = splitTeamRecipients(recipients);
        const prevFirstConsumerId = this.state.sensorbox?.consumer?.[0]?._id;
        const nextFirstConsumerId = split.email[0]?._id;
        let inspectionList: any[] = [];

        if (split.email[0]) {
            const inspectionsListFromApi = await InspectionChecklistServices.getInspectionsList({
                customer: split.email[0]._id,
                orgid: this.props?.organisationId,
            });
            inspectionList = inspectionsListFromApi?.data?.inspections?.map((inspection: any) => {
                const address = (inspection?.consumer_data?.street && inspection?.consumer_data?.city && inspection?.consumer_data?.state)
                    ? `${inspection?.consumer_data?.street}, ${inspection?.consumer_data?.city}, ${inspection?.consumer_data?.state} `
                    : '-';
                return { _id: inspection?._id, name: `${inspection?.system_name} / ${address}` };
            }) || [];
        }

        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} });
        }

        Object.assign(this.state.sensorbox, {
            consumer: split.email,
            mobile_consumer: split.sms,
            voice_consumer: split.voice,
            inspection: prevFirstConsumerId !== nextFirstConsumerId ? '' : this.state.sensorbox.inspection,
        });

        this.setState({ sensorbox: this.state.sensorbox, inspectionList }, () => {
            this.getCustomerList();
        });
    }

    updateEmailContractor = (data : any)=> {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        const contractorAndTeam = this.convertDropdownData(data,'r')
        Object.assign(this.state.sensorbox, { contractor : contractorAndTeam })
        this.setState({sensorbox : this.state.sensorbox},()=>{
            this.getContractorList()
        })
    }

    updateMobileContractor = (data : any)=> {
        if(!this.state.sensorbox){
            Object.assign(this.state, {sensorbox : {}})
        }

        const contractorAndTeam = this.convertDropdownData(data,'r')
        Object.assign(this.state.sensorbox, { mobile_contractor : contractorAndTeam })
        this.setState({sensorbox : this.state.sensorbox},()=>{
            this.getContractorList()
        })
    }

    async getContractorList() {       
        try{
            let contractorList = []
            let selectedItem;
            if(authStore?.currentUser?.access?.includes(view_contractor_sensorboxes_assets)) {

                    selectedItem = {_id : authStore.currentUser.uid, name : authStore.currentUser.name}
                    if(!this.state.sensorbox){
                        Object.assign(this.state, {sensorbox : {}})
                    }
                    Object.assign(this.state.sensorbox, { contractor : [selectedItem] })
                    this.setState({sensorbox: this.state.sensorbox});
                
            }else if(authStore?.currentUser?.access?.includes(view_assigned_users_sensorboxes_assets)){

                selectedItem = userStore.profileDetials && userStore.profileDetials.assigned_to;
                if(!this.state.sensorbox){
                    Object.assign(this.state, {sensorbox : {}})
                }
                Object.assign(this.state.sensorbox, { contractor : [selectedItem] })
                this.setState({sensorbox: this.state.sensorbox});
                
            }else{
                contractorList = await userService.getContractorList(this.props?.organisationId)
                if(!this.state.sensorbox){
                    Object.assign(this.state, {sensorbox : {}})
                }

                if(authStore?.currentUser?.active_role?.role_type === -1) {
                    contractorList = contractorList.map((item: any, index :any) => ({...item, name: `Contractor ${index+1}`}))
                }

                this.setState({contractorList});
            }                        

        }catch(error){
            toast.error(error.response.data.message)
        } 
    }

    thPinCombination = (sensorType : any, value : any) => {
        const { sensorTypeList , pinConfigList } = this.state;
        if(sensorType.sensor_name_abbr === "th_sensor1_db"){ // th pin1.
            sensorTypeList.forEach((type: any) => {
                    let returnHumidityPins = [...pinConfigList[17]]
                    let combinationPin = returnHumidityPins.find((pin: any) => pin.representation === value?.combination_pin);
                    let pin_type = '', representation = '', sub_type = '' ;
                    if(type.sensor_name_abbr === "th_sensor1_rh" && combinationPin){ // return humidity
                        pin_type = combinationPin?.type;
                        representation = combinationPin?.representation;
                        sub_type = combinationPin?.sub_type;

                        type.pin_type = pin_type;
                        type.representation = representation;
                        type.subtype = sub_type

                        const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === type?.sensor_name_abbr);

                        if (index >= 0) {
                            this.sensorArray[index].sensor_name = type?.sensor_name_abbr;
                            this.sensorArray[index].sub_type = sub_type;
                            this.sensorArray[index].representation = representation;
                            this.sensorArray[index].pin_type = pin_type;
                        }else{
                            let sensorObject: any = {
                                sensor_name: type?.sensor_name_abbr,
                                representation,
                                sensor_type: type,
                                pin_type
                            }
            
                            if(sub_type) sensorObject.sub_type = sub_type;            
                            this.sensorArray.push(sensorObject);
                        }  
                    }
            })
        }else if(sensorType.sensor_name_abbr === "th_sensor2_db"){
            sensorTypeList.forEach((type: any) => {
                let returnAndSupplyHumidityPins = [...pinConfigList[18]]
                let combinationPin = returnAndSupplyHumidityPins.find((pin: any) => pin.representation === value?.combination_pin);
                let pin_type = '', representation = '', sub_type = '' ; 
                if(type.sensor_name_abbr === "th_sensor2_rh" && combinationPin){

                    pin_type = combinationPin?.type;
                    representation = combinationPin?.representation;
                    sub_type = combinationPin?.sub_type;

                    type.pin_type = pin_type;
                    type.representation = representation;
                    type.subtype = sub_type

                    const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === type?.sensor_name_abbr);

                    if (index >= 0) {
                        this.sensorArray[index].sensor_name = type?.sensor_name_abbr;
                        this.sensorArray[index].sub_type = sub_type;
                        this.sensorArray[index].representation = representation;
                        this.sensorArray[index].pin_type = pin_type;
                    }else{
                        let sensorObject: any = {
                            sensor_name: type?.sensor_name_abbr,
                            representation,
                            sensor_type: type,
                            pin_type
                        }
        
                        if(sub_type) sensorObject.sub_type = sub_type;            
                        this.sensorArray.push(sensorObject);
                    }  
                }  
            })
        }
        else if(sensorType.sensor_name_abbr === "th_sensor1_rh"){
            sensorTypeList.forEach((type: any) => {
                let thPins = [...pinConfigList[3] , ...pinConfigList[4] , ...pinConfigList[19]]
                let combinationPin = thPins.find((pin: any) => pin.representation === value?.combination_pin);
                if(type.sensor_name_abbr === "th_sensor1_db" && combinationPin){
                    let pin_type = '', representation = '', sub_type = '' ; 

                    pin_type = combinationPin?.type;
                    representation = combinationPin?.representation;
                    sub_type = combinationPin?.sub_type;

                    type.pin_type = pin_type;
                    type.representation = representation;
                    type.subtype = sub_type

                    const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === type?.sensor_name_abbr);

                    if (index >= 0) {
                        this.sensorArray[index].sensor_name = type?.sensor_name_abbr;
                        this.sensorArray[index].sub_type = sub_type;
                        this.sensorArray[index].representation = representation;
                        this.sensorArray[index].pin_type = pin_type;
                    }else{
                        let sensorObject: any = {
                            sensor_name: type?.sensor_name_abbr,
                            representation,
                            sensor_type: type,
                            pin_type
                        }
        
                        if(sub_type) sensorObject.sub_type = sub_type;            
                        this.sensorArray.push(sensorObject);
                    }  
                }      
            })

        }
        else if(sensorType.sensor_name_abbr === "th_sensor2_rh"){
            sensorTypeList.forEach((type: any) => {
                let thPins = [...pinConfigList[3] , ...pinConfigList[4] , ...pinConfigList[19]]
                let combinationPin = thPins.find((pin: any) => pin.representation === value?.combination_pin);
                if(type.sensor_name_abbr === "th_sensor2_db" && combinationPin){
                    let pin_type = '', representation = '', sub_type = '' ; 

                    pin_type = combinationPin?.type;
                    representation = combinationPin?.representation;
                    sub_type = combinationPin?.sub_type;

                    type.pin_type = pin_type;
                    type.representation = representation;
                    type.subtype = sub_type

                    const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === type?.sensor_name_abbr);

                    if (index >= 0) {
                        this.sensorArray[index].sensor_name = type?.sensor_name_abbr;
                        this.sensorArray[index].sub_type = sub_type;
                        this.sensorArray[index].representation = representation;
                        this.sensorArray[index].pin_type = pin_type;
                    }else{
                        let sensorObject: any = {
                            sensor_name: type?.sensor_name_abbr,
                            representation,
                            sensor_type: type,
                            pin_type
                        }
        
                        if(sub_type) sensorObject.sub_type = sub_type;            
                        this.sensorArray.push(sensorObject);
                    }  
                }      
            })
        }
    }

    updatePinType = (sensorType: any, sensorTypeItem: any, value: any) => {
        sensorType.min = '';
        sensorType.max = '';

        this.thPinCombination(sensorType, value)
        if (sensorType.is_configurable.includes(1)) {
            sensorType.pin_type = value;
            sensorType.representation = '';
            sensorType.calibration_c = 1
            sensorType.calibration_a = 0
            sensorType.calibration_b = 0
            sensorType.calibration_d = 0
            const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr);
            if (index >= 0) {
                this.sensorArray[index].pin_type = value;
                this.sensorArray[index].representation = '';
                this.sensorArray[index].calibration_c = 1
                this.sensorArray[index].calibration_a = 0
                this.sensorArray[index].calibration_b = 0
                this.sensorArray[index].calibration_d = 0
                this.sensorArray[index].sensor_type.calibration_c = 1
                this.sensorArray[index].sensor_type.calibration_a = 0
                this.sensorArray[index].sensor_type.calibration_b = 0
                this.sensorArray[index].sensor_type.calibration_d = 0
                this.sensorArray[index].sensor_type.pin_type = value;
                this.sensorArray[index].sensor_type.representation = '';
                this.sensorArray[index].sensor_type.min = '';
                this.sensorArray[index].sensor_type.max = '';
                if (this.sensorArray[index].auto_limit) {
                    this.sensorArray[index].auto_limit = {
                        latest_estimation: {
                            min: 0,
                            max: 0
                        }
                    };
                }
            }

            sensorTypeItem.forEach((sensor: any) => {
                if (
                    sensor.sensor_name_abbr === sensorType.sensor_name_abbr
                ) {
                    sensor.pin_type = value;
                    sensor.representation = '';
                    sensor.min = '';
                    sensor.max = '';
                    if (sensor.auto_limit) {
                        sensor.auto_limit = {
                            latest_estimation: {
                                min: 0,
                                max: 0
                            }
                        };
                    }
                }
            });

            this.state.sensorTypeList.forEach((sensor: any) => {
                if (
                    sensor.sensor_name_abbr === sensorType.sensor_name_abbr
                ) {
                    sensor.pin_type = value;
                    sensor.representation = '';
                    sensor.min = '';
                    sensor.max = '';
                    sensor.calibration_c = 1
                    sensor.calibration_a = 0
                    sensor.calibration_b = 0
                    sensor.calibration_d = 0
                }
            });
        } else {
            sensorType.sub_type = value?.sub_type;
            sensorType.representation = value?.representation;
            sensorType.pin_type = value?.type;
            sensorType.calibration_c = 1
            sensorType.calibration_a = 0
            sensorType.calibration_b = 0
            sensorType.calibration_d = 0
            const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr);
            if (index >= 0) {
                this.sensorArray[index].sub_type = value?.sub_type;
                this.sensorArray[index].representation = value?.representation;
                this.sensorArray[index].pin_type = value?.type;
                this.sensorArray[index].sensor_type.sub_type = value?.sub_type;
                this.sensorArray[index].sensor_type.representation = value?.representation;
                this.sensorArray[index].sensor_type.pin_type = value?.type;
                this.sensorArray[index].sensor_type.min = '';
                this.sensorArray[index].sensor_type.max = '';
                this.sensorArray[index].calibration_c = 1
                this.sensorArray[index].calibration_a = 0
                this.sensorArray[index].calibration_b = 0
                this.sensorArray[index].calibration_d = 0
                this.sensorArray[index].sensor_type.calibration_c = 1
                this.sensorArray[index].sensor_type.calibration_a = 0
                this.sensorArray[index].sensor_type.calibration_b = 0
                this.sensorArray[index].sensor_type.calibration_d = 0
                if (this.sensorArray[index].auto_limit) {
                    this.sensorArray[index].auto_limit = {
                        latest_estimation: {
                            min: 0,
                            max: 0
                        }
                    };
                }
            }

            sensorTypeItem.forEach((sensor: any) => {
                if (
                    sensor.sensor_name_abbr === sensorType.sensor_name_abbr
                ) {
                    sensor.representation = value?.representation;
                    sensor.pin_type = value?.type;
                    sensor.sub_type = value?.sub_type;
                    sensor.min = '';
                    sensor.max = '';
                    if (sensor.auto_limit) {
                        sensor.auto_limit = {
                            latest_estimation: {
                                min: 0,
                                max: 0
                            }
                        };
                    }
                }
            });

            this.state.sensorTypeList.forEach((sensor: any) => {
                if (
                    sensor.sensor_name_abbr === sensorType.sensor_name_abbr
                ) {
                    sensor.representation = value?.representation;
                    sensor.pin_type = value?.type;
                    sensor.sub_type = value?.sub_type;
                    sensor.min = '';
                    sensor.max = '';
                    sensor.calibration_c = 1
                    sensor.calibration_a = 0
                    sensor.calibration_b = 0
                    sensor.calibration_d = 0
                }
            });
        }
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    selectAll = (event: ChangeEvent<HTMLInputElement>) => {
        const { sensorTypeList, pinConfigList, sensorbox } = this.state;
        if(event.target.checked) {
            sensorTypeList.forEach((type: any) => {
                const groundedCondtion = (this.state?.sensorbox?.hasOwnProperty('_id') && type?.sensor_name_abbr === 'gpio_pin6' && this.state.sensorbox?.version as any <= 3) ? false : type?.sensor_name_abbr === 'gpio_pin6'
                const combinationPinCondition = (sensorbox?.board_version as number >=6  && (type?.sensor_name_abbr === 'th_sensor1_rh' || type?.sensor_name_abbr === 'th_sensor2_rh'))
                let isInvalidPin = ( type?.sensor_name_abbr === 'blower_current' && sensorbox?.version !== 1 ) || groundedCondtion || combinationPinCondition                 
                const index = this.sensorArray.findIndex((s:any) => s.sensor_name === type.sensor_name_abbr)
                if(index < 0 && !isInvalidPin) {
                    let pin_type = '', representation = '', sub_type = '', calibration_c ,calibration_d , calibration_a ,calibration_b ; 
                    if(type?.is_configurable?.includes(0)) {
                        pin_type = type?.type;
                        representation =  type?.represent;
                    }else if(type?.is_configurable.includes(1)) {
                        pin_type = Object.keys(pinConfigList['1'])[0]
                        representation = pinConfigList['1'][pin_type][0]?.representation
                        sub_type = pinConfigList['1'][pin_type][0]?.sub_type
                        calibration_c = 1
                        calibration_a = 0
                        calibration_b = 0
                        calibration_d = 0

                    }else if(!type?.is_configurable.includes(0) && !type?.is_configurable.includes(1)) {
                        const options = type?.is_configurable?.reduce((a: any, c: string) => (pinConfigList[c] ? [...a, ...pinConfigList[c] ] : a), []);
                        this.thPinCombination(type, options[0])
                        pin_type = options[0]?.type;
                        representation = options[0]?.representation;
                        sub_type = options[0]?.sub_type;
                    }

                    type.pin_type = pin_type;
                    type.representation = representation;
                    
                    let sensorObject: any = {
                        sensor_name: type?.sensor_name_abbr,
                        representation,
                        sensor_type: type,
                        pin_type
                    }
                    if(sub_type) sensorObject.sub_type = sub_type;

                    if(calibration_c !== undefined ) sensorObject.calibration_c = calibration_c;
                    if(calibration_d !== undefined) sensorObject.calibration_d = calibration_d;

                    if(calibration_a !== undefined ) sensorObject.calibration_a = calibration_a;
                    if(calibration_b !== undefined) sensorObject.calibration_b = calibration_b;
    
                    this.sensorArray.push(sensorObject);
                }
            })
        }else {
            sensorTypeList.forEach((type: any) => {
                type.pin_type = '';
                type.representation = '';
                type.sub_type = '';
                if(type?.is_configurable?.includes(1)) {
                    type.calibration_c = 1
                    type.calibration_a = 0
                    type.calibration_b = 0
                    type.calibration_d = 0
                }
            })
            
            this.sensorArray = [];
        }
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    deselectAll = (event: ChangeEvent<HTMLInputElement>) => {
        const { sensorTypeList } = this.state;
        sensorTypeList.forEach((type: any) => {
            type.pin_type = '';
            type.representation = '';
            type.sub_type = '';
            if(type?.is_configurable?.includes(1)) {
                type.calibration_c = 1
                type.calibration_a = 0
                type.calibration_b = 0
                type.calibration_d = 0
            }
        })
            
        this.sensorArray = [];
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    updatePinRepresentation = (sensorType: any, sensorTypeItem: any, value: any) => {
        sensorType.representation = value?.representation;
        sensorType.sub_type = value?.sub_type;
        sensorType.min = '';
        sensorType.max = '';

        const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr);
        if (index >= 0) {
            this.sensorArray[index].representation = value?.representation;
            this.sensorArray[index].sub_type = value?.sub_type;
            this.sensorArray[index].sensor_type.representation = value?.representation;
            this.sensorArray[index].sensor_type.sub_type = value?.sub_type;
            this.sensorArray[index].sensor_type.min = '';
            this.sensorArray[index].sensor_type.max = '';
            if (this.sensorArray[index].auto_limit) {
                this.sensorArray[index].auto_limit = {
                    latest_estimation: {
                        min: 0,
                        max: 0
                    }
                };
            }
        }

        sensorTypeItem.forEach((sensor: any) => {
            if (
                sensor.sensor_name_abbr === sensorType.sensor_name_abbr
            ) {
                sensor.representation = value?.representation;
                sensor.sub_type = value?.sub_type;
                sensor.min = '';
                sensor.max = '';
                if (sensor.auto_limit) {
                    sensor.auto_limit = {
                        latest_estimation: {
                            min: 0,
                            max: 0
                        }
                    };
                }
            }
        });
        this.state.sensorTypeList.forEach((sensor: any) => {
            if (
                sensor.sensor_name_abbr === sensorType.sensor_name_abbr
            ) {
                sensor.representation = value?.representation;
                sensor.sub_type = value?.sub_type;
                sensor.min = '';
                sensor.max = '';
            }
        });

        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    updatePinTypeExternal = (sensorType: any, sensorTypeItem: any, value: any) => {
        // Wrapper for external sensors - similar logic to updatePinType but for external sensor structure
        sensorType.min = '';
        sensorType.max = '';

        if (sensorType.is_configurable.includes(0)) {
            sensorType.pin_type = value;
            sensorType.representation = '';
            sensorType.calibration_c = 1
            sensorType.calibration_a = 0
            sensorType.calibration_b = 0
            sensorType.calibration_d = 0
            const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr);
            if (index >= 0) {
                this.sensorArray[index].pin_type = value;
                this.sensorArray[index].representation = '';
                this.sensorArray[index].calibration_a = 0
                this.sensorArray[index].calibration_b = 0
                if (this.sensorArray[index].sensor_type) {
                    this.sensorArray[index].sensor_type.calibration_a = 0
                    this.sensorArray[index].sensor_type.calibration_b = 0
                    this.sensorArray[index].sensor_type.pin_type = value;
                    this.sensorArray[index].sensor_type.representation = '';
                    this.sensorArray[index].sensor_type.min = '';
                    this.sensorArray[index].sensor_type.max = '';
                }
                if (this.sensorArray[index].auto_limit) {
                    this.sensorArray[index].auto_limit = {
                        latest_estimation: {
                            min: 0,
                            max: 0
                        }
                    };
                }
            }

            sensorTypeItem.forEach((sensor: any) => {
                if (sensor.sensor_name_abbr === sensorType.sensor_name_abbr) {
                    sensor.pin_type = value;
                    sensor.representation = '';
                    sensor.min = '';
                    sensor.max = '';
                    if (sensor.auto_limit) {
                        sensor.auto_limit = {
                            latest_estimation: {
                                min: 0,
                                max: 0
                            }
                        };
                    }
                }
            });

            this.state.sensorTypeList.forEach((sensor: any) => {
                if (sensor.sensor_name_abbr === sensorType.sensor_name_abbr) {
                    sensor.pin_type = value;
                    sensor.representation = '';
                    sensor.min = '';
                    sensor.max = '';
                    sensor.calibration_c = 1
                    sensor.calibration_a = 0
                    sensor.calibration_b = 0
                    sensor.calibration_d = 0
                }
            });
        }
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    updatePinRepresentationExternal = (sensorType: any, sensorTypeItem: any, value: any) => {
        // Wrapper for external sensors - similar logic to updatePinRepresentation but for external sensor structure
        sensorType.representation = value?.representation;
        sensorType.sub_type = value?.sub_type;
        sensorType.min = '';
        sensorType.max = '';

        const index = this.sensorArray.findIndex((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr);
        if (index >= 0) {
            this.sensorArray[index].representation = value?.representation;
            this.sensorArray[index].sub_type = value?.sub_type;
            if (this.sensorArray[index].sensor_type) {
                this.sensorArray[index].sensor_type.representation = value?.representation;
                this.sensorArray[index].sensor_type.sub_type = value?.sub_type;
                this.sensorArray[index].sensor_type.min = '';
                this.sensorArray[index].sensor_type.max = '';
            }
            if (this.sensorArray[index].auto_limit) {
                this.sensorArray[index].auto_limit = {
                    latest_estimation: {
                        min: 0,
                        max: 0
                    }
                };
            }
        }

        sensorTypeItem.forEach((sensor: any) => {
            if (sensor.sensor_name_abbr === sensorType.sensor_name_abbr) {
                sensor.representation = value?.representation;
                sensor.sub_type = value?.sub_type;
                sensor.min = '';
                sensor.max = '';
                if (sensor.auto_limit) {
                    sensor.auto_limit = {
                        latest_estimation: {
                            min: 0,
                            max: 0
                        }
                    };
                }
            }
        });
        this.state.sensorTypeList.forEach((sensor: any) => {
            if (sensor.sensor_name_abbr === sensorType.sensor_name_abbr) {
                sensor.representation = value?.representation;
                sensor.sub_type = value?.sub_type;
                sensor.min = '';
                sensor.max = '';
            }
        });

        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })
    }

    onChangeDeploymentStatus = (date : any , type : any, action : any) =>{

        let isInvalid = true
        if(action === '' && date){
            isInvalid = false
        }else if(action === "clear" && date === null){
            isInvalid = false
        }

        Object.assign(this.state.sensorbox, { [type] : date ? date.getTime() : '' })
        this.setState({sensorbox : this.state.sensorbox, invalidDeploymentStatusDate : isInvalid})
    }

    updateSensorData = (minVal: any, maxVal: any, sensor_type: any, ml_accepted: boolean) => {
        sensor_type.min = minVal;
        sensor_type.max = maxVal;
        this.sensorArray.forEach((sensor: any) => {
            if (
                sensor.sensor_name === sensor_type.sensor_name_abbr &&
                sensor.sensor_type
            ) {
                sensor.sensor_type.min = minVal;
                sensor.sensor_type.max = maxVal;
                sensor.sensor_type.limit_updated_at = new Date().getTime();
                sensor.auto_limit.is_current_autolimit = ml_accepted;
            }
        });
        
        this.state.sensorTypeList.forEach((sensor: any) => {
            if (
                sensor.sensor_name_abbr === sensor_type.sensor_name_abbr
            ) {
                sensor.min = minVal;
                sensor.max = maxVal;
                sensor.limit_updated_at = new Date().getTime();
                sensor.auto_limit.is_current_autolimit = ml_accepted;
            }
        });
        
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox})
    }

    updateSensorType = (e: any, sensor_type: any) => {
        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} })
        }

        let sensor_name = ''
        let sensorObject = {} as any;
        let error = {} as any
        let isValid = true

        const { pinConfigList, sensorbox } = this.state;
        const isExternal = sensorbox?.sensor_box_source === 'external' || sensor_type?.source === 'external';

        if (this.state.sensorbox && !this.state.sensorbox.sensor_box_name) {
            error.sensors = constants.message.sensor_name_mandatory
            isValid = false
            this.setState({ error })
            return isValid

        } else if (this.state.sensorbox && this.state.sensorbox.sensor_box_name && sensor_type) {

            sensor_name = sensor_type.sensor_name_abbr;
            sensorObject = {
                sensor_name: sensor_name,
                sensor_type: sensor_type,
            }
            if (e.target.checked && e.target.name !== 'gpio_pin4_energized') {
                if (!this.sensorArray.includes(sensorObject)) {
                    let pin_type = '', representation = '', sub_type = '';
                    if(sensor_type?.is_configurable.includes(0)){
                        pin_type = sensor_type?.type;
                        representation =  sensor_type?.represent;
                    }else if(sensor_type?.is_configurable.includes(1)) {
                        pin_type = Object.keys(pinConfigList['1'])[0]
                        representation = pinConfigList['1'][pin_type][0]?.representation
                        sub_type = pinConfigList['1'][pin_type][0]?.sub_type
                        sensorObject.calibration_c = 1
                        sensorObject.calibration_a = 0
                        sensorObject.calibration_b = 0
                        sensorObject.calibration_d = 0
                    }else if(!sensor_type?.is_configurable.includes(0) && !sensor_type?.is_configurable.includes(1)) {
                        const options = sensor_type?.is_configurable?.reduce((a: any, c: string) => (pinConfigList[c] ? [...a, ...pinConfigList[c] ] : a), []);
                        this.thPinCombination(sensor_type, options[0])
                        pin_type = options[0]?.type;
                        representation = options[0]?.representation;
                        sub_type = options[0]?.sub_type;
                    }
                    sensorObject.pin_type = pin_type;
                    sensorObject.representation = representation;
                    if(sub_type) sensorObject.sub_type = sub_type;

                    sensor_type.pin_type = pin_type;
                    sensor_type.representation = representation;

                    if (sensor_type?.external) {
                        sensorObject.external = sensor_type.external;
                    }
                    if (sensor_type?.comp_info) {
                        sensorObject.comp_info = sensor_type.comp_info;
                    }
                    this.sensorArray.push(sensorObject);
                }
            }

            else if (["min", "max"].includes(e.target.name)) {
                sensor_type[e.target.name] = e.target.value;
                this.sensorArray.forEach((sensor: any) => {
                    if (sensor.sensor_name === sensor_type.sensor_name_abbr && sensor.sensor_type) {
                        sensor.sensor_type[e.target.name] = e.target.value
                        sensor.sensor_type.limit_updated_at = new Date().getTime();

                        if (sensor.auto_limit?.latest_estimation) {
                            let min = Number(sensor.sensor_type?.min || 0);
                            let max = Number(sensor.sensor_type?.max || 0);
                          if (min === Number(sensor.auto_limit?.latest_estimation?.min) && max === Number(sensor.auto_limit?.latest_estimation?.max)) {
                            sensor.auto_limit.is_current_autolimit = true;
                          } else {
                            sensor.auto_limit.is_current_autolimit = false;
                          }
                        }
                    }
                })
            }


            else if (["calibration_c", "calibration_d", "calibration_a", "calibration_b"].includes(e.target.name)) {
                sensor_type[e.target.name] = e.target.value;
                this.sensorArray.forEach((sensor: any) => {
                    if (sensor.sensor_name === sensor_type.sensor_name_abbr) {
                        sensor[e.target.name] = e.target.value
                    }
                })
            }

            else if (e.target.name === 'gpio_pin4_energized') {

                this.swapSPI_Pins()  // to swap SPI_1 pin and SPI_2 pin values when the gpio4 energize checkbox is clicked

            } else if (["component", "comp_seq", "type", "sub_type"].includes(e.target.name) && isExternal) {
                // Handle component schema updates for external sensors
                // The sensor_type passed is the updated item with comp_info
                if (sensor_type && sensor_type.comp_info) {
                    // Update sensor in array if it exists
                    this.sensorArray.forEach((sensor: any) => {
                        if (sensor.sensor_name === sensor_type.sensor_name_abbr) {
                            sensor.comp_info = sensor_type.comp_info;
                            if (sensor.sensor_type) {
                                sensor.sensor_type.comp_info = sensor_type.comp_info;
                            }
                        }
                    })

                    const { sensorTypeList } = this.state
                    sensorTypeList.forEach((sensorType: any) => {
                        if(sensorType.sensor_name_abbr === sensor_type.sensor_name_abbr){
                            sensorType.comp_info = sensor_type.comp_info;
                        }      
                    })
                }
            } else if (!["min", "max", "calibration_c", "calibration_d", "calibration_a", "calibration_b"].includes(e.target.name)) {

                let currentSensorArray = this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors : [];               
                let current_array = currentSensorArray.filter((sensor_types: any) => {
                    let sensors: any = sensor_type;
                    return sensor_types.sensor_name !== sensors.sensor_name_abbr
                });

                if(e.target.name !== "thpincheckbox" && sensorbox?.board_version as number >= 6){
                    if(sensor_type.sensor_name_abbr === "th_sensor1_db"){

                        current_array = current_array.filter((sensor_types: any) => {
                            return sensor_types.sensor_name !== "th_sensor1_rh"
                        });

                        const { sensorTypeList } = this.state

                        sensorTypeList.forEach((sensor_type: any) => {
                            if(sensor_type.sensor_name_abbr === "th_sensor1_rh"){
                                sensor_type.pin_type = '';
                                sensor_type.sub_type = '';
                                sensor_type.representation = '';
                                if (sensor_type.max !== undefined) {
                                    sensor_type.max = '';
                                }
                
                                if (sensor_type.min !== undefined) {
                                    sensor_type.min = '';
                                }

                            }      
                        })
                    }else if(sensor_type.sensor_name_abbr === "th_sensor2_db"){
                        current_array = current_array.filter((sensor_types: any) => {
                            return sensor_types.sensor_name !== "th_sensor2_rh"
                        });

                        const { sensorTypeList } = this.state

                        sensorTypeList.forEach((sensor_type: any) => {
                            if(sensor_type.sensor_name_abbr === "th_sensor2_rh"){
                                sensor_type.pin_type = '';
                                sensor_type.sub_type = '';
                                sensor_type.representation = '';
                                if (sensor_type.max !== undefined) {
                                    sensor_type.max = '';
                                }
                
                                if (sensor_type.min !== undefined) {
                                    sensor_type.min = '';
                                }

                            }      
                        })

                    }else if(sensor_type.sensor_name_abbr === "th_sensor1_rh"){
                        current_array = current_array.filter((sensor_types: any) => {
                            return sensor_types.sensor_name !== "th_sensor1_db"
                        });

                        const { sensorTypeList } = this.state

                        sensorTypeList.forEach((sensor_type: any) => {
                            if(sensor_type.sensor_name_abbr === "th_sensor1_db"){
                                sensor_type.pin_type = '';
                                sensor_type.sub_type = '';
                                sensor_type.representation = '';
                                if (sensor_type.max !== undefined) {
                                    sensor_type.max = '';
                                }
                
                                if (sensor_type.min !== undefined) {
                                    sensor_type.min = '';
                                }

                            }      
                        })

                    }else if(sensor_type.sensor_name_abbr === "th_sensor2_rh"){
                        current_array = current_array.filter((sensor_types: any) => {
                            return sensor_types.sensor_name !== "th_sensor2_db"
                        });

                        const { sensorTypeList } = this.state

                        sensorTypeList.forEach((sensor_type: any) => {
                            if(sensor_type.sensor_name_abbr === "th_sensor2_db"){
                                sensor_type.pin_type = '';
                                sensor_type.sub_type = '';
                                sensor_type.representation = '';
                                if (sensor_type.max !== undefined) {
                                    sensor_type.max = '';
                                }
                
                                if (sensor_type.min !== undefined) {
                                    sensor_type.min = '';
                                }

                            }      
                        })

                    }
                }  
                

                this.sensorArray = current_array

                sensor_type.pin_type = '';
                sensor_type.sub_type = '';
                sensor_type.representation = '';

                if (sensor_type.max !== undefined) {
                    sensor_type.max = '';
                }

                if (sensor_type.min !== undefined) {
                    sensor_type.min = '';
                }

                if (sensor_type.calibration_c !== undefined) {
                    sensor_type.calibration_c = 1;
                }

                if (sensor_type.calibration_d !== undefined) {
                    sensor_type.calibration_d = 0;
                }

                if (sensor_type.calibration_a !== undefined) {
                    sensor_type.calibration_a = 0;
                }

                if (sensor_type.calibration_b !== undefined) {
                    sensor_type.calibration_b = 0;
                }

                if (e.target.name === 'gpio_pin4') {
                    this.swapSPI_Pins()
                }

            }

            Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
            this.setState({ sensorbox: this.state.sensorbox ,validRangeError : '', validCalibrationError : '' })
        }
    }

       swapSPI_Pins = () => {

        let spi_pin1_Obj: any, spi_pin2_Obj: any
        
        this.sensorArray.forEach((sensor: any) => {
            if (sensor.sensor_name === "spi_pin1") {
                spi_pin1_Obj = Object.assign({}, sensor);
            } else if (sensor.sensor_name === "spi_pin2") {
                spi_pin2_Obj = Object.assign({}, sensor);
            }
        })

           if (this.checkEnergizedCondition(spi_pin1_Obj, spi_pin2_Obj)) {
               this.sensorArray.forEach(async (sensor: any) => {

                if (sensor.sensor_name === "spi_pin1" || sensor.sensor_name === "spi_pin2") {

                    const isSPI_Pin1 = sensor.sensor_name === "spi_pin1"
                    sensor.representation = isSPI_Pin1 ? spi_pin2_Obj.representation : spi_pin1_Obj.representation
                    sensor.sub_type = isSPI_Pin1 ? spi_pin2_Obj.sub_type : spi_pin1_Obj.sub_type
                    
                    const pin = this.state.sensorTypeList?.find((s: any) => s?.sensor_name_abbr === sensor.sensor_name);
                    pin.representation = isSPI_Pin1 ? spi_pin2_Obj.representation : spi_pin1_Obj.representation;
                    pin.sub_type = isSPI_Pin1 ? spi_pin2_Obj.sub_type : spi_pin1_Obj.sub_type

                }
            })
        }
    }

    checkEnergizedCondition = (spi_pin1_Obj: any, spi_pin2_Obj: any) => {
        return (spi_pin1_Obj && spi_pin2_Obj && (
            (spi_pin1_Obj.sub_type === 'liquid_temp' && spi_pin2_Obj.sub_type === 'suction_temp') ||
            (spi_pin1_Obj.sub_type === 'suction_temp' && spi_pin2_Obj.sub_type === 'liquid_temp')
        ))
    }

    // Expand LGMV sensor types based on idu_count
    expandLgmvSensorTypes = (sensorTypeList: any[], iduCount: number): any[] => {
        const expandedList: any[] = [];
        
        sensorTypeList.forEach((sensorType: any) => {
            // Check if this sensor type has IDU placeholder pattern
            // Pattern: sensor_name_abbr contains '{{ idu_count }}'
            const hasIduPlaceholder = sensorType.sensor_name_abbr?.includes('{{ idu_count }}');
            
            if (hasIduPlaceholder && iduCount > 0) {
                // Expand this sensor type for each IDU (1 to iduCount)
                for (let i = 1; i <= iduCount; i++) {
                    const expandedType = {
                        ...sensorType,
                        sensor_name_abbr: sensorType.sensor_name_abbr?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                        name: sensorType.name?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                        display_name: sensorType.display_name?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                        external: sensorType.external ? {
                            ...sensorType.external,
                            field_location: sensorType.external.field_location?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                        } : sensorType.external
                    };
                    expandedList.push(expandedType);
                }
            } else {
                // Regular sensor type, add as is
                // Ensure display_name exists, fallback to name or sensor_name_abbr
                if (!sensorType.display_name) {
                    sensorType.display_name = sensorType.external?.field_name || sensorType.name || sensorType.sensor_name_abbr || '';
                }
                expandedList.push(sensorType);
            }
        });
        
        return expandedList;
    }

    // Re-expand LGMV sensor types when idu_count changes
    reExpandLgmvSensorTypes = async (iduCount: number) => {
        const isLgmv = this.state.sensorbox?.sensor_box_source === 'external' && 
                     (this.state.sensorbox?.source_type?.toLowerCase() === 'lgmv' || 
                      this.state.sensorbox?.sensor_box_type?.toLowerCase() === 'lgmv');
        
        if (isLgmv) {
            // Re-fetch sensor types from backend to get base types with placeholders
            // This ensures we always have the original template sensor types
            await this.getSensorTypeList();
        }
    }

    async getSensorTypeList() {
        try {
            const sensorBoxSource = this.state.sensorbox?.sensor_box_source || 'internal'
            const sourceType = this.state.sensorbox?.source_type || null
            let sensorTypeList = await userService.getSensorTypeList(sensorBoxSource, sourceType)
            if (!this.state.sensorbox) {
                Object.assign(this.state, { sensorbox: {} })
            }

            // For LGMV external sensors, expand sensor types based on idu_count
            const isLgmv = this.state.sensorbox?.sensor_box_source === 'external' && 
                         (this.state.sensorbox?.source_type?.toLowerCase() === 'lgmv' || 
                          this.state.sensorbox?.sensor_box_type?.toLowerCase() === 'lgmv');
            
            if (isLgmv && sensorTypeList) {
                // Get idu_count from sensorbox, default to 1 if undefined
                const iduCount = this.state.sensorbox?.idu_count !== undefined && this.state.sensorbox?.idu_count !== null 
                    ? this.state.sensorbox.idu_count 
                    : 1;
                sensorTypeList = this.expandLgmvSensorTypes(sensorTypeList, iduCount);
            }

            // For external sensors, board_version might not be relevant, so handle differently
            let sortedPinsBasedOnBoardVersions = sensorTypeList?.map((item: any, index: any) => {
                // External sensors might not have pin_order, so handle that
                if (item.pin_order && item.pin_order.length > 0 && this.state.sensorbox?.board_version) {
                    let pin_order = item.pin_order.find((pin: any) => {
                        return pin.board_version === this.state.sensorbox?.board_version
                    })
                    return pin_order ? {...item, pinOrder: pin_order?.order} : item 
                }
                // For external sensors or sensors without pin_order, use order field directly
                return {...item, pinOrder: item.order || 1000 + index}
            }).sort((a: any, b: any) => (a?.pinOrder - b?.pinOrder))

            await this.sensorType(sortedPinsBasedOnBoardVersions)
        } catch (error) {
            // toast.error(error.response.data.message)
        }
    }

    async getSensorTemplates() {
        try {
            const sensorBoxSource = this.state.sensorbox?.sensor_box_source || 'internal'
            let sensorTemplates
            if (sensorBoxSource === 'external') {
                sensorTemplates = await userService.getExternalSensorTemplates()
            } else {
                sensorTemplates = await userService.getInternalSensorTemplates()
            }
            if (!this.state.sensorbox) {
                Object.assign(this.state, { sensorbox: {} })
            }

            
            this.setState({ sensorTemplates:  sensorTemplates });
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error fetching templates')
        }
    }

    async sensorType (sensorTypeList : any){
        sensorTypeList.forEach((sensorType: any) => {
            if (this.state.sensorbox && this.state.sensorbox.sensors) {
                let sensor = this.state.sensorbox.sensors.filter((sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr)[0]
                if (sensorType.min !== undefined && sensorType.max !== undefined) {
                    sensorType.min = (sensor && sensor.sensor_type && sensor.sensor_type.min) ? sensor.sensor_type.min : '';
                    sensorType.max = (sensor && sensor.sensor_type && sensor.sensor_type.min) ? sensor.sensor_type.max : '';
                    sensorType.calibration_c = (sensor?.calibration_c !== undefined ) ? sensor.calibration_c : 1 ;
                    sensorType.calibration_a = (sensor?.calibration_a !== undefined ) ? sensor.calibration_a : 0 ;
                    sensorType.calibration_b = (sensor?.calibration_b !== undefined ) ? sensor.calibration_b : 0 ;
                    sensorType.calibration_d = (sensor?.calibration_d !== undefined ) ? sensor.calibration_d : 0 ;
                }
                sensorType.pin_type = (sensor && sensor.pin_type) ? sensor.pin_type : '';
                sensorType.representation = (sensor && sensor.representation) ? sensor.representation :  '';
                sensorType.sub_type = (sensor && sensor.sub_type) ? sensor.sub_type : '';
                sensorType.limit_updated_at = (sensor && sensor.sensor_type && sensor.sensor_type.limit_updated_at) ? sensor.sensor_type.limit_updated_at : 0;
                sensorType.auto_limit = (sensor && sensor.auto_limit) ? sensor.auto_limit : {};
                
                // Preserve external mapping for external sensors
                if (sensor && sensor.external) {
                    sensorType.external = sensor.external;
                }
                
                // Preserve comp_info for external sensors
                if (sensor && sensor.comp_info) {
                    sensorType.comp_info = sensor.comp_info;
                }
                
                // Preserve display_name from sensor_type if available
                if (sensor && sensor.sensor_type && sensor.sensor_type.display_name) {
                    sensorType.display_name = sensor.sensor_type.display_name;
                }
            }
            else if(sensorType?.is_configurable?.includes(1)) {
                sensorType.calibration_c = 1
                sensorType.calibration_a = 0
                sensorType.calibration_b = 0
                sensorType.calibration_d = 0
            }
            
            // Ensure display_name exists for external sensors, fallback to name or sensor_name_abbr
            // if (!sensorType.display_name && (this.state.sensorbox?.sensor_box_source === 'external')) {
            //     sensorType.display_name = sensorType.name || sensorType.sensor_name_abbr || '';
            // }
        })

        this.setState({ sensorTypeList: JSON.parse(JSON.stringify(sensorTypeList)), sensorTypeListCopy: JSON.parse(JSON.stringify(sensorTypeList)) });
    }

    async getPinConfiguration() {
        try {
            const resp = await pinConfigurationService.getPinConfiguration();

            if (resp) {
                const { pin_configuration } = resp.data;
                const i2cCombinationPins = pin_configuration?.filter((config: any) => config.pin_type === 19); //combination pin type i2c sh and th
                const types: any = _.groupBy(pin_configuration, 'pin_type');
                if (this.state.sensorbox?.sensor_box_source === 'external') {
                    types['1'] = [...pin_configuration]
                } else {
                    types['1'] = [...types['1'] , ...i2cCombinationPins] // merge i2c combination pins with i2c types
                }
                
                types['1'] = _.groupBy(types['1'], 'type');

                for (const key in types['1']){
                    types['1'][key]?.sort((a:any, b:any) => {
                        const name_a  = a?.display_name ?? ''
                        const name_b  = b?.display_name ?? ''
                        const aIsAlphabetical = name_a.localeCompare("a") >= 0
                        const bIsAlphabetical = name_b.localeCompare("a") >= 0
                        if (!aIsAlphabetical && bIsAlphabetical)
                            return 1;
                        if (aIsAlphabetical && !bIsAlphabetical)
                            return -1;
                        return name_a.localeCompare(name_b);
                    })
                }

                this.setState({ pinConfigList: types })
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }


    async getSensorBoxDetails(id: string){        
        try{
            let sensorTypeList = await userService.getSensorBoxList(id)
            if(!this.state.sensorbox){
                Object.assign(this.state, {sensorbox : {}})
            }        
            this.setState({sensorTypeList});       

        }catch(error){
            toast.error(error.response.data.message)
        }
    }

    closeForm = () => {   
        this.setState({sensorbox : undefined,isEdit : false,consumerList : [],contractorList:[],sensorTypeList:[],tabhomeactive : true,tabactive : false},()=>{
            if(Utility.checkModalOpen('confirmmodal')) {
                Utility.closeModal('confirmmodal')
            }
            this.props.setVisibleClose()
            Utility.closeModal('sensorboxdetails')
            this.props.clearSelectedSensorBox()
        })
    }

    showDeleteConfirm() {
        Utility.closeModal('sensorboxdetails')        
        Utility.showModal('confirmmodal')
    }

    closeConfirmModal(){
        Utility.closeModal('confirmmodal')
        Utility.showModal('sensorboxdetails')

    }
    


    isSelected(){
        return this.state.sensorbox !== undefined && this.state.sensorbox._id !== undefined && !this.state.isEdit
    }
    

    isValidSensorDetails(){
        let sensorbox       =   this.state.sensorbox
        let error           =   {} as any
        let isValid         =   true
       
        if(sensorbox ) {
            if(validate.isEmpty(sensorbox.sensor_box_name)){
                error.sensor_box_name =  constants.message.sensor_name_mandatory
                isValid    =  false
            }
            if(!validate.isValidCharacter(sensorbox.sensor_box_name)){
                error.sensor_box_name = constants.message.box_name_valid
                isValid    =  false
            }        

            if(!sensorbox.category){
                error.category = constants.message.sensorbox_category_required
                isValid    =  false
            }

            if(!sensorbox.place || validate.isEmpty(sensorbox.place)){
                error.place = constants.message.address_mandatory
                isValid = false
            }

            if(sensorbox.sensor_box_source === 'external') {
                if(!sensorbox.source_id || validate.isEmpty(sensorbox.source_id)){
                    error.source_id = constants.message.source_id_required || 'Source ID is required'
                    isValid = false
                }
                if(!sensorbox.source_type || validate.isEmpty(sensorbox.source_type)){
                    error.source_type = constants.message.source_type_required || 'Source Type is required'
                    isValid = false
                }
                if(!sensorbox.sensor_box_type){
                    error.sensor_box_type = constants.message.sensor_box_type_required || 'Sensor Box Type is required'
                    isValid = false
                }
            } else {
                if(!sensorbox.device_type){
                    error.device_type = constants.message.device_type_required
                    isValid    =  false
                }

                // Board version is not required for external sensor boxes
                if(!sensorbox.board_version && sensorbox.sensor_box_source !== 'external'){
                    error.board_version = constants.message.board_version_required
                    isValid    =  false
                }

            if(!sensorbox.heat_provided_by){
                error.heat_provided_by = constants.message.heat_provided_by_required
                isValid    =  false
            }
    
            if(sensorbox.heat_provided_by === 'heat-pump'){
                if(!sensorbox.rv_mode){
                    error.rv_mode = constants.message.rv_mode_required
                    isValid    =  false
                }
            }
            

            if(!validate.isValidModel(sensorbox.system_model)){
                error.system_model = constants.message.system_model_valid
                isValid    =  false
            }

            if(!validate.isValidModel(sensorbox.evaporator_motor_model)){
                error.evaporator_motor_model = constants.message.name_valid
                isValid    =  false
            }

            if(!validate.isValidModel(sensorbox.condensor_motor_model)){
                error.condensor_motor_model = constants.message.name_valid
                isValid    =  false
            }

            if(sensorbox.compressor_model && !validate.isValidModel(sensorbox.compressor_model) ){
                error.compressor_model = constants.message.name_valid
                isValid    =  false
            }

            if(!validate.isValidModel(sensorbox.expansion_valve_model)){
                error.expansion_valve_model = constants.message.name_valid
                isValid    =  false
            }
            

            if(sensorbox.nominal_cooling_capacity && !validate.isValidValue(sensorbox.nominal_cooling_capacity)) {
                error.nominal_cooling_capacity = constants.message.capacity_value_invalid
                isValid    =  false
            }

            if(sensorbox.nominal_heating && !validate.isValidValue(sensorbox.nominal_heating)) {
                error.nominal_heating = constants.message.heating_value_invalid
                isValid    =  false
            }


            if((sensorbox.location && (sensorbox.location.coordinates[0]) && validate.isEmpty( sensorbox.location.coordinates[1] ))){
                error.location =  constants.message.location_mandatory
                isValid    =  false
            }

            if(sensorbox.location && (validate.isEmpty(sensorbox.location.coordinates[0]) && (sensorbox.location.coordinates[1]))){
                error.location =  constants.message.location_mandatory
                isValid    =  false
            }
            if(sensorbox.sensors) {
                sensorbox.sensors.forEach(sensor => {
                    if(sensor.sensor_type && sensor.sensor_type.min !== undefined && sensor.sensor_type.max !== undefined) {
                        if((sensor.sensor_type.min === '' && sensor.sensor_type.max.length > 0 ) || (sensor.sensor_type.min.length > 0 && sensor.sensor_type.max === '' )) {
                            this.setState({validRangeError : constants.message.max_min_value_mandatory+` for ${sensor.sensor_name} sensor.`})
                            isValid         = false
                        }
                        else if((sensor.sensor_type.min !== '' &&  sensor.sensor_type.max !== '')) {
                            if(isNaN(parseFloat(sensor.sensor_type.min)) || isNaN(parseFloat(sensor.sensor_type.max ))) {
                                this.setState({validRangeError : constants.message.max_min_invalid_value+` for ${sensor.sensor_name} sensor.`})
                                isValid         = false
                            }
                            else if (parseFloat(sensor.sensor_type.min) >= parseFloat(sensor.sensor_type.max)) {
                                this.setState({validRangeError : constants.message.max_must_be_greater_than_min+` for ${sensor.sensor_name} sensor.`})
                                isValid         = false
                            }
                            
                        }
                    }

                    if(sensor && sensor.calibration_c && sensor.calibration_c !== undefined ) {

                        if(!(validate.isValidCalibration(String(sensor.calibration_c)))){
                            this.setState({validCalibrationError : constants.message.calibration_must_be_range+` for ${sensor.sensor_name} sensor.`})
                            isValid         = false
                        }

                    }

                    if(sensor && sensor.calibration_d  && sensor.calibration_d !== undefined ) {

                        if(!(validate.isValidCalibration(String(sensor.calibration_d)))){
                            this.setState({validCalibrationError : constants.message.calibration_must_be_range+` for ${sensor.sensor_name} sensor.`})
                            isValid         = false
                        }

                    }

                    if(sensor && sensor.calibration_a && sensor.calibration_a !== undefined ) {

                        if(!(validate.isValidCalibration(String(sensor.calibration_a)))){
                            this.setState({validCalibrationError : constants.message.calibration_must_be_range+` for ${sensor.sensor_name} sensor.`})
                            isValid         = false
                        }

                    }

                    if(sensor && sensor.calibration_b && sensor.calibration_b !== undefined ) {

                        if(!(validate.isValidCalibration(String(sensor.calibration_b)))){
                            this.setState({validCalibrationError : constants.message.calibration_must_be_range+` for ${sensor.sensor_name} sensor.`})
                            isValid         = false
                        }

                    }
                })
            }
            if(this.state.invalidDeploymentStatusDate){
                isValid    =  false
            }
            
        }     
        this.setState({error})
        return isValid
        }
    }

    isFormat() {
        if(this.state.sensorbox){
            Object.entries(this.state.sensorbox).forEach(item=>{                
                if(typeof item[1] ==="string") {
                    Object.assign(this.state.sensorbox,{[item[0]] : item[1].trim()})
                }else{
                    Object.assign(this.state.sensorbox,{[item[0]] : item[1]})
                }
            }) 
        }
    }

    isValidFormatValue = async() => {
        let error           =   {} as any
        let isValid         =   true;

        if(this.state.sensorbox ) {

            if(!validate.isValidFormatValue(this.state.sensorbox.nominal_cooling_capacity) ) {              
                error.nominal_cooling_capacity = constants.message.capacity_value_invalid
                isValid = false;
            }
            if(!validate.isValidFormatValue(this.state.sensorbox.nominal_heating) ) {
                error.nominal_heating = constants.message.heating_value_invalid
                isValid = false;
            }
            if(!validate.isValidAirflowFormat(this.state.sensorbox.airflow) ) {
                error.airflow = constants.message.airflow_invalid
                isValid = false;
            }
            const offlineCheckDuration = this.state.sensorbox.offline_check_duration
            if (offlineCheckDuration !== null && offlineCheckDuration !== undefined && String(offlineCheckDuration) !== '') {
                const parsedDuration = parseInt(String(offlineCheckDuration), 10)
                if (_.isNaN(parsedDuration) || parsedDuration < 1) {
                    error.offline_check_duration = 'Offline check duration should not be less than 1 minute'
                    isValid = false
                }
            } 
            if(this.state.sensorbox.place) {
                let addressCheck = await this.addressCheck();
                if(!addressCheck){
                    error.place = constants.message.address_valid
                    isValid = false;
                } 
            }                                
            
        }
        this.setState({error})
        return isValid;

    }

    addressCheck = async () => {
        let error = {} as any
        let addressValid = await this.coordinates();
        if(addressValid) {           
            return true;           
        } else{
            error.place = constants.message.address_valid
            this.setState({error}); 
            return false;
        }              
       
    }

    validatePinConfiguration = () => {
        const errors: any = {};
        const { sensorbox } = this.state
        let isExternal = sensorbox?.sensor_box_source === 'external'
        if (isExternal) {
            sensorbox?.sensors?.forEach((sensor: any) => {
                if (!sensor?.external) {
                    errors[sensor.sensor_name] = 'Select pin configuration';
                }

                if (!sensor?.comp_info || !sensor?.comp_info?.comp_type || !sensor?.comp_info?.type) {
                    errors[sensor.sensor_name] = 'Select component schema';
                }
            })
        }

        sensorbox?.sensors?.forEach((sensor: any) => {
            if (!sensor?.representation) {
                errors[sensor.sensor_name] = 'Select pin configuration';
            }
        })

        if (isExternal) {
            sensorbox?.sensors?.forEach((sensor: any) => {
                const hasSchema = sensor?.comp_info?.comp_type && sensor?.comp_info?.type;
                const sub = sensor?.comp_info?.sub;
                if (hasSchema && (sub == null || String(sub).trim() === '')) {
                    errors[sensor.sensor_name] = 'Select representation';
                }
            })
        }
        this.setState({ pinError: errors });
        return !Object.keys(errors).some(field => field !== '');
    }

    checkSensor = async() =>{
        
        let isSensorExist = await this.sensorBoxExist(); 
        if(!isSensorExist){           
            let validFormat =  await this.isValidFormatValue();
            if(validFormat) {
                this.isFormat();  
                let validSensorDetails = await this.isValidSensorDetails();
                let pinValid = await this.validatePinConfiguration();
                if(validSensorDetails && pinValid){
                    return true;
                }else{
                    return false;
                }
            
            }else {
                return false
            }            
        }
        return false;
    }

    setSensorNameBasedonSensorBoxName() {
        if(this.state.sensorbox && this.state.sensorbox.sensors) {
            this.state.sensorbox.sensors.forEach((item)=>{
                let sensorBoxName = this.state.sensorbox?this.state.sensorbox.sensor_box_name:"";
                item.sensor_name = sensorBoxName + item.sensor_type.sensor_name_abbr;
            })
        }
    }

    reconnetToSSE = async () => {
        await eventStore.connectEventSource();
        this.props.updateEventSourceListener();
    }

    async moveSensorBox(){
        this.setState({ showMoveSensorboxModal :true })
        Utility.closeModal('sensorboxdetails')
    }

    closeMoveSensorboxModal = (orgName : any) => {
        if(this.state.sensorbox){
            toast.success(`Moved the ${this.state.sensorbox?.sensor_box_name} to ${orgName} organization`)
            this.setState({isLoading : true})
            this.setState({isLoading : false , showMoveSensorboxModal :false},()=>{
                this.closeForm()
                let currentPage = this.props.shouldPageChange(false)
                this.props.updateSensorBoxList(currentPage)
            })                
        }
    }

    closeMoveSensorsModal = () => {
        this.setState({ showMoveSensorboxModal :false })
        Utility.showModal('sensorboxdetails')
    }

    async saveSensors(action = ''){      
        // Sync sensorArray to sensorbox.sensors before filtering
        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} })
        }
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        
        let isExternal = this.state.sensorbox?.sensor_box_source === 'external'
        let sensors :any = []
        if (isExternal) {
            sensors = this.state.sensorbox?.sensors?.filter((sensor: any) => this.state.sensorTypeList?.find((sensorType:any)=>(sensorType?.sensor_name_abbr === sensor?.sensor_name)))
            // Update external.field_location for monnit sensor boxes with source_id
            if (this.state.sensorbox?.sensor_box_type == "monnit" && sensors) {
                sensors.forEach((sensor: any) => {
                    const sourceId = this.state.sensorbox?.source_id || '';
                    
                    // Update sensor.external.field_location
                    if (sensor.external && sensor.external.field_location) {
                        sensor.external.field_location = sensor.external.field_location.replace(/\{\{ source_id \}\}/g, sourceId);
                    }
                    
                    // Update sensor.sensor_type.external.field_location
                    if (sensor.sensor_type && sensor.sensor_type.external && sensor.sensor_type.external.field_location) {
                        sensor.sensor_type.external.field_location = sensor.sensor_type.external.field_location.replace(/\{\{ source_id \}\}/g, sourceId);
                    }
                });
            }
            // Default comp_seq to 1 if empty or not provided when saving
            sensors.forEach((sensor: any) => {
                if (sensor.comp_info) {
                    if (sensor.comp_info.comp_seq === undefined || sensor.comp_info.comp_seq === '' || sensor.comp_info.comp_seq === null) {
                        sensor.comp_info.comp_seq = 1;
                    }
                    // Also update in sensor_type if it exists
                    if (sensor.sensor_type && sensor.sensor_type.comp_info) {
                        if (sensor.sensor_type.comp_info.comp_seq === undefined || sensor.sensor_type.comp_info.comp_seq === '' || sensor.sensor_type.comp_info.comp_seq === null) {
                            sensor.sensor_type.comp_info.comp_seq = 1;
                        }
                    }
                }
            });
        } else {
            sensors = this.state.sensorbox?.sensors?.filter((sensor: any) => this.state.sensorTypeList?.find((sensorType:any)=>(sensorType?.sensor_name_abbr === sensor?.sensor_name))?.board_version?.includes(this.state.sensorbox?.board_version))
        }

        Object.assign(this.state.sensorbox, { sensors : sensors })
        
        // For LGMV external sensorboxes, ensure idu_count is saved
        if (isExternal && this.state.sensorbox?.sensor_box_source === 'external') {
            const isLgmv = this.state.sensorbox?.source_type?.toLowerCase() === 'lgmv' || 
                          this.state.sensorbox?.sensor_box_type?.toLowerCase() === 'lgmv';
            if (isLgmv) {
                // idu_count should already be set via onIduCountChange callback, but ensure it's there
                // If not set, default to 1
                if (this.state.sensorbox.idu_count === undefined || this.state.sensorbox.idu_count === null) {
                    Object.assign(this.state.sensorbox, { idu_count: 1 });
                }
            }
        }
        
        this.setState({sensorbox : this.state.sensorbox})

            let isAddOperation = false;
            let currentPage = 0;
            try{
                this.setState({isLoading : true})          
                let sensorExist = await this.checkSensor();
                if(sensorExist){                
                        
                    if(this.state.sensorbox && this.state.sensorbox._id) {
                        this.setState({ saveConfirmationModal :true , saveType : action , isLoading : false})
                        Utility.closeModal('sensorboxdetails')

                    }else {
                        // note : temp solution for the org admin access to all org
                        await userService.createSensorBox(this.state.sensorbox, action === 'send' ,this.props?.organisationId);
                        await this.reconnetToSSE();
                        isAddOperation = true;
                        this.setState({isLoading : false},()=>{
                            if(isAddOperation) {
                                currentPage = this.props.shouldPageChange(false)
                            } 
                            if(action === 'export'){
                                this.exportConfigHandler(this.state.sensorbox)
                            }else{
                                this.closeForm()
                            }
                        this.props.updateSensorBoxList(currentPage)
                        })
                    }
                }
                else{
                    this.setState({isLoading : false})       
                }                
            }catch(error){
                this.setState({isLoading : false})
                toast.error(error?.response?.data?.message)
            }
    }




    toggleEdit() {
        const { sensorTypeListCopy } = this.state

        let userAccessArray = this.state?.consumerList?.filter((item:any)=>(
            this.props.sensorbox?.user_access?.includes(item?._id)
        ))  
            
        let userAccessObject = userAccessArray?.map((item:any)=>({value:item._id,label:item.name})) 

        let category = categoryOptions.find((value:any)=>(value._id === this.props.sensorbox?.category)) 
        const sensorBoxSource = this.props.sensorbox?.sensor_box_source || 'internal'
        this.sensorArray = this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors : [];
        this.setState({
            isEdit       : !this.state.isEdit,
            invalidDeploymentStatusDate : false,
            sensorbox    : {...JSON.parse(JSON.stringify(this.props.sensorbox)) ,category : category ,board_version : this.props.sensorbox?.board_version , userAccessObject, sensor_box_source: sensorBoxSource},
            sensorTypeList: JSON.parse(JSON.stringify(sensorTypeListCopy)),
            error        : {} as any,    
        })
    }

    showPillTab = () => {
        this.setState({tabactive :!this.state.tabactive,tabhomeactive :!this.state.tabhomeactive});
    }

    showPillTabHome = () => {
        this.setState({tabactive :!this.state.tabactive,tabhomeactive :!this.state.tabhomeactive},() =>{
        });
        
    }


    getNewSensorBoxName = async() => {
          
        
        let sensorboxcount = await userService.getNewSensorBoxName();
        let sensorName = 'SYS' + sensorboxcount?.toString().padStart(8, '0');
        
        Object.assign(this.state.sensorbox,{sensor_box_name : sensorName });
        this.setState({sensorbox : this.state.sensorbox})
    

    }

    clearSensorTypes = () => {
        const { sensorTypeList } = this.state
        sensorTypeList.forEach((type: any) => {
            type.pin_type = '';
            type.representation = '';
            type.sub_type = '';
            if(type?.is_configurable?.includes(1)) {
                type.calibration_c = 1
                type.calibration_a = 0
                type.calibration_b = 0
                type.calibration_d = 0
            }
        })
    } 

    // Helper function to generate sensor type from template config item (for expanded LGMV sensors)
    generateSensorTypeFromConfig = (pinConfig: any, template: any, index: number): any => {
        // Get unit format based on field_type (similar to backend logic)
        const getUnitAndFormat = (fieldType: string) => {
            const mapping: any = {
                'float': { unit: '', format_type: 2 },
                'int': { unit: '', format_type: 2 },
                'string': { unit: '', format_type: 1 },
                'boolean': { unit: '', format_type: 0 }
            };
            return mapping[fieldType] || { unit: '', format_type: 2 };
        };

        const unitFormat = getUnitAndFormat(pinConfig.external?.field_type || 'float');
        
        return {
            name: pinConfig.external?.name || pinConfig.display_name || pinConfig.sensor_name || '',
            sensor_unit: unitFormat.unit,
            sensor_name_abbr: pinConfig.sensor_name,
            represent: pinConfig.representation || '',
            min: '',
            max: '',
            order: index + 1000,
            type: pinConfig.pin_type || 'unknown',
            is_configurable: [0], // External sensors are fixed
            sensor_format_type: unitFormat.format_type,
            board_version: template.board_version || [],
            pin_order: [],
            source: 'external',
            source_type: template.source_type,
            calibration_c: 1,
            calibration_a: 0,
            calibration_b: 0,
            calibration_d: 0,
            auto_limit: {},
            external: pinConfig.external || {},
            display_name: pinConfig.display_name || ''
        };
    }

    updateTemplateForBoardVersion = (template: any) => {
        this.clearSensorTypes()
        this.sensorArray = [];
        const { sensorTypeList, pinConfigList, sensorTypeListCopy } = this.state;

        const isExternalTemplate = template.source === 'external' || this.state.sensorbox?.sensor_box_source === 'external';
        if (isExternalTemplate) {
            Object.assign(this.state.sensorbox, { source_type: template.source_type });
        }
        
        // For external templates, generate sensor types dynamically from expanded config
        // This handles LGMV templates with IDU expansion where sensor types don't exist in sensorTypeListCopy
        let availableSensorTypes = [...(sensorTypeListCopy || [])];
        if (isExternalTemplate && template.config) {
            template.config.forEach((pinConfig: any, index: number) => {
                // Check if sensor type exists in sensorTypeListCopy
                const existingType = sensorTypeListCopy?.find((type: any) => 
                    pinConfig.sensor_name === type.sensor_name_abbr
                );
                
                // If not found, generate it from the config (for expanded LGMV sensors)
                if (!existingType && pinConfig.sensor_name) {
                    const generatedType = this.generateSensorTypeFromConfig(pinConfig, template, index);
                    availableSensorTypes.push(generatedType);
                } else if (existingType && pinConfig.display_name) {
                    // Update display_name for existing types from template config
                    existingType.display_name = pinConfig.display_name;
                    // Also update in availableSensorTypes
                    const typeInAvailable = availableSensorTypes.find((type: any) => 
                        type.sensor_name_abbr === pinConfig.sensor_name
                    );
                    if (typeInAvailable) {
                        typeInAvailable.display_name = pinConfig.display_name;
                    }
                }
            });
        }
        
        // Track sensor names present in the template for external templates
        const templateSensorNames = new Set<string>();
        template.config.forEach((pinConfig: any) => {
            let type = sensorTypeList?.find((type : any) => (pinConfig.sensor_name  === type.sensor_name_abbr));
            
            // Track sensor names in template for external templates
            if (isExternalTemplate) {
                templateSensorNames.add(pinConfig.sensor_name);
                // First try sensorTypeListCopy, then try availableSensorTypes (which includes generated types)
                type = sensorTypeListCopy?.find((type : any) => (pinConfig.sensor_name  === type.sensor_name_abbr));
                if (!type) {
                    type = availableSensorTypes.find((type : any) => (pinConfig.sensor_name  === type.sensor_name_abbr));
                }
            }
            
            if (!type) {
                return; // Skip if sensor type not found
            }
            
            let pin_type = '', representation = '', sub_type = '', calibration_c ,calibration_d , calibration_a ,calibration_b ; 
            
            // Handle external templates differently
            if (isExternalTemplate) {
                if (pinConfig.calibration_c !== undefined) calibration_c = pinConfig.calibration_c;
                if (pinConfig.calibration_d !== undefined) calibration_d = pinConfig.calibration_d;
                if (pinConfig.calibration_a !== undefined) calibration_a = pinConfig.calibration_a;
                if (pinConfig.calibration_b !== undefined) calibration_b = pinConfig.calibration_b;
                
                if (pinConfig.external) {
                    // Deep copy external config to ensure it's properly preserved
                    type.external = {
                        field_location: pinConfig.external.field_location || '',
                        field_type: pinConfig.external.field_type || '',
                        field_name: pinConfig.external.field_name || ''
                    };
                }
                
                // Store display_name from template if available (new schema)
                // Also update it in sensorTypeList so it's available in ExternalSensorConfig
                if (pinConfig.display_name) {
                    type.display_name = pinConfig.display_name;
                    // Update display_name in sensorTypeList as well
                    const sensorTypeInList = this.state.sensorTypeList?.find((st: any) => 
                        st.sensor_name_abbr === type.sensor_name_abbr
                    );
                    if (sensorTypeInList) {
                        sensorTypeInList.display_name = pinConfig.display_name;
                    }
                }
                
                // For external sensors, don't set pin_type/representation/sub_type from template
                // These will be set from component schema selection in UI
                pin_type = pinConfig.pin_type;
                representation =  pinConfig.representation;
                sub_type = '';
            } else if(type?.is_configurable?.includes(0)) {
                // Internal fixed sensors
                pin_type = pinConfig.pin_type;
                representation =  pinConfig.representation;
            }else if(type?.is_configurable.includes(1)) {
                // Internal configurable sensors
                pin_type = pinConfig.pin_type
                representation = pinConfig.representation
                sub_type = pinConfig.sub_type
                calibration_c = 1
                calibration_a = 0
                calibration_b = 0
                calibration_d = 0

            }else if(!type?.is_configurable.includes(0) && !type?.is_configurable.includes(1)) {
                let thPins = [...pinConfigList[3] , ...pinConfigList[4] , ...pinConfigList[19]]
                let thPinValue = thPins.find((pin:any)=>(pin.representation === pinConfig.representation)) 
                if(thPinValue !== undefined){
                    this.thPinCombination(type, thPinValue)
                }
                pin_type = pinConfig.pin_type;
                representation = pinConfig.representation;
                sub_type = pinConfig.sub_type;
            }

            type.pin_type = pin_type;
            type.representation = representation;
                
            let sensorObject: any = {
                sensor_name: type?.sensor_name_abbr,
                representation,
                sensor_type: type,
                pin_type
            }

            if(sub_type) sensorObject.sub_type = sub_type;

            if(calibration_c !== undefined ) sensorObject.calibration_c = calibration_c;
            if(calibration_d !== undefined) sensorObject.calibration_d = calibration_d;

            if(calibration_a !== undefined ) sensorObject.calibration_a = calibration_a;
            if(calibration_b !== undefined) sensorObject.calibration_b = calibration_b;

            // Preserve external mapping object for external sensors
            // New schema: external object contains field_location, field_type, field_name
            if (isExternalTemplate && pinConfig.external) {
                sensorObject.external = {
                    field_location: pinConfig.external.field_location || '',
                    field_type: pinConfig.external.field_type || '',
                    field_name: pinConfig.external.field_name || ''
                };
            }

            this.sensorArray.push(sensorObject);
        })
        
        // For external templates, filter availableSensorTypes to only include sensors present in the template
        // This includes both existing sensor types and dynamically generated ones (for expanded LGMV sensors)
        if (isExternalTemplate && templateSensorNames.size > 0) {
            const filteredSensorTypeList = availableSensorTypes.filter((type: any) => 
                templateSensorNames.has(type.sensor_name_abbr)
            );
            
            // Update display_name from template config for all filtered sensor types
            filteredSensorTypeList.forEach((type: any) => {
                const matchingConfig = template.config.find((config: any) => 
                    config.sensor_name === type.sensor_name_abbr
                );
                if (matchingConfig && matchingConfig.display_name) {
                    type.display_name = matchingConfig.display_name;
                }
            });
            
            // Update both sensorTypeList and sensorTypeListCopy to include generated types
            this.setState({ 
                sensorTypeList: filteredSensorTypeList,
                sensorTypeListCopy: availableSensorTypes // Keep all available types including generated ones
            });
        }
        
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })   
    }

    clickPinNumberOnBoard = (checked : any,item: any) => {
        const { sensorTypeList, pinConfigList, sensorbox } = this.state;
        let sensor_name = ''
        let sensorObject = {} as any;
        sensorTypeList.forEach((sensor_type: any) => {
            if(sensor_type.sensor_name_abbr === item.sensor_name_abbr){
                sensor_name = sensor_type.sensor_name_abbr;
                if(checked){
                    sensorObject = {
                        sensor_name: sensor_name,
                        sensor_type: sensor_type,
                    }
                    let pin_type = '', representation = '', sub_type = '';
                    if(sensor_type?.is_configurable.includes(0)){
                        pin_type = sensor_type?.type;
                        representation =  sensor_type?.represent;
                    }else if(sensor_type?.is_configurable.includes(1)) {
                        pin_type = Object.keys(pinConfigList['1'])[0]
                        representation = pinConfigList['1'][pin_type][0]?.representation
                        sub_type = pinConfigList['1'][pin_type][0]?.sub_type
                        sensorObject.calibration_c = 1
                        sensorObject.calibration_a = 0
                        sensorObject.calibration_b = 0
                        sensorObject.calibration_d = 0
                    }else if(!sensor_type?.is_configurable.includes(0) && !sensor_type?.is_configurable.includes(1)) {
                        const options = sensor_type?.is_configurable?.reduce((a: any, c: string) => (pinConfigList[c] ? [...a, ...pinConfigList[c] ] : a), []);
                        this.thPinCombination(sensor_type, options[0])
                        pin_type = options[0]?.type;
                        representation = options[0]?.representation;
                        sub_type = options[0]?.sub_type;
                    }
                    sensorObject.pin_type = pin_type;
                    sensorObject.representation = representation;
                    if(sub_type) sensorObject.sub_type = sub_type;

                    sensor_type.pin_type = pin_type;
                    sensor_type.representation = representation;
                    this.sensorArray.push(sensorObject);     
                }else{

                    let currentSensorArray = this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors : [];
               
                    let current_array = currentSensorArray.filter((sensor_types: any) => {
                        let sensors: any = sensor_type;
                        return sensor_types.sensor_name !== sensors.sensor_name_abbr
                    });

                    if(sensorbox?.board_version  as number >= 6){
                        if(sensor_type.sensor_name_abbr === "th_sensor1_db"){

                            current_array = current_array.filter((sensor_types: any) => {
                                return sensor_types.sensor_name !== "th_sensor1_rh"
                            });
                
                            const { sensorTypeList } = this.state
                
                            sensorTypeList.forEach((sensor_type: any) => {
                                if(sensor_type.sensor_name_abbr === "th_sensor1_rh"){
                                    sensor_type.pin_type = '';
                                    sensor_type.sub_type = '';
                                    sensor_type.representation = '';
                
                                }      
                            })
                        }else if(sensor_type.sensor_name_abbr === "th_sensor2_db"){
                            current_array = current_array.filter((sensor_types: any) => {
                                return sensor_types.sensor_name !== "th_sensor2_rh"
                            });
                
                            const { sensorTypeList } = this.state
                
                            sensorTypeList.forEach((sensor_type: any) => {
                                if(sensor_type.sensor_name_abbr === "th_sensor2_rh"){
                                    sensor_type.pin_type = '';
                                    sensor_type.sub_type = '';
                                    sensor_type.representation = '';
                
                                }      
                            })
                
                        }else if(sensor_type.sensor_name_abbr === "th_sensor1_rh"){
                            current_array = current_array.filter((sensor_types: any) => {
                                return sensor_types.sensor_name !== "th_sensor1_db"
                            });
                
                            const { sensorTypeList } = this.state
                
                            sensorTypeList.forEach((sensor_type: any) => {
                                if(sensor_type.sensor_name_abbr === "th_sensor1_db"){
                                    sensor_type.pin_type = '';
                                    sensor_type.sub_type = '';
                                    sensor_type.representation = '';
                
                                }      
                            })
                
                        }else if(sensor_type.sensor_name_abbr === "th_sensor2_rh"){
                            current_array = current_array.filter((sensor_types: any) => {
                                return sensor_types.sensor_name !== "th_sensor2_db"
                            });
                
                            const { sensorTypeList } = this.state
                
                            sensorTypeList.forEach((sensor_type: any) => {
                                if(sensor_type.sensor_name_abbr === "th_sensor2_db"){
                                    sensor_type.pin_type = '';
                                    sensor_type.sub_type = '';
                                    sensor_type.representation = '';
                
                                }      
                            })
                
                        }
                    }

                    sensor_type.pin_type = '';
                    sensor_type.sub_type = '';
                    sensor_type.representation = '';

                    if (sensor_type.max !== undefined) {
                        sensor_type.max = '';
                    }

                    if (sensor_type.min !== undefined) {
                        sensor_type.min = '';
                    }

                    if (sensor_type.calibration_c !== undefined) {
                        sensor_type.calibration_c = 1;
                    }

                    if (sensor_type.calibration_d !== undefined) {
                        sensor_type.calibration_d = 0;
                    }

                    if (sensor_type.calibration_a !== undefined) {
                        sensor_type.calibration_a = 0;
                    }

                    if (sensor_type.calibration_b !== undefined) {
                        sensor_type.calibration_b = 0;
                    }

                    this.sensorArray = current_array
                    
                }  
            }  
        })
        
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        this.setState({ sensorbox: this.state.sensorbox })   
    }


    exportConfigHandler = async(sensorbox? : SensorBox) => {
        const { sensorTypeList } = this.state;
        const sensors = this.sensorArray.slice();
        if(!sensorbox?.sensor_box_name || !sensors?.length) return
        
        const excludedPins = ['sc', 'sh', 'blower_current']
        const filteredSensorTypeList = sensorTypeList.filter((sensor: any) => sensor.board_version?.includes(this.state.sensorbox?.board_version))
        const allPins = filteredSensorTypeList.map((type: any) => type?.sensor_name_abbr).filter(type => !excludedPins.includes(type))
        
        const pins = sensors.filter((sensor: any) => !excludedPins.includes(sensor.sensor_name) && this.state.sensorTypeList?.find((sensorType:any)=>(sensorType?.sensor_name_abbr === sensor?.sensor_name))?.board_version?.includes(this.state.sensorbox?.board_version))
        .map((sensor: any) => {
            let pin: any = { pin: sensor.sensor_name, type: sensor.pin_type };
            if(sensor?.sub_type) pin.sub_type = sensor?.sub_type

            if(sensor?.calibration_a !== undefined && sensor?.calibration_a !== null && sensor?.calibration_a !== "") pin.cb_mul1 = Number(sensor?.calibration_a)
            if(sensor?.calibration_b !== undefined && sensor?.calibration_b !== null && sensor?.calibration_b !== "") pin.cb_mul2 = Number(sensor?.calibration_b)
            if(sensor?.calibration_c !== undefined && sensor?.calibration_c !== null && sensor?.calibration_c !== "") pin.cb_mul3 = Number(sensor?.calibration_c)
            if(sensor?.calibration_d !== undefined && sensor?.calibration_d !== null && sensor?.calibration_d !== "") pin.cb_mul4 = Number(sensor?.calibration_d)
            return pin
        })
        
        const filter = allPins.filter(pin => !pins.some((s: any) => s.pin === pin));
    
        let jsonData: any = {};
        jsonData.config = {};
        jsonData.config.version = 'v3';
        jsonData.config.serial = sensorbox?.latest_config_version ? sensorbox?.latest_config_version : 0;
        jsonData.config.sys_name = sensorbox?.sensor_box_name;
        jsonData.config.board_version = sensorbox?.board_version;
        jsonData.config.devel = process.env.REACT_APP_ENV === 'PROD' ? 0 : 1;
        jsonData.config.unit_off_interval = 60.0;
        jsonData.config.unit_on_interval = 5.0;
        jsonData.config.read_interval = sensorbox?.read_interval ?? 1;
        jsonData.config.filter = filter;
        jsonData.config.pins = pins;

        let jsonString = JSON.stringify(jsonData, null, 2);
        const blob = new Blob([jsonString], { type: 'application/json' });
        const href = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = href;
        link.download = "config.json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.closeForm()
    }

    customerDatas = (customerData : any) => {

        let filteredUsers = customerData.filter((customer : any) => {
            const role = customer.roles.filter((role : any) => role.role_type > 1)
            return role.length > 0
        })

        let result = filteredUsers?.filter((customer :any) =>customer._id!== '' && this.state.sensorbox?.consumer?.findIndex(x=> x._id == customer._id) == -1 &&
            this.state.sensorbox?.contractor?.findIndex(x=> x._id == customer._id) == -1)
        return result
    }

    handleUserAccessSelection(option: any) {

        if(!option.length){
            Object.assign(this.state.sensorbox, { user_access : [] }) // set assigned to state to null when role is empty
        }

        const optionValue = option.map((item :any) => item.value)

        Object.assign(this.state.sensorbox, {user_access : optionValue , userAccessObject : option })
        this.setState({sensorbox  : {...JSON.parse(JSON.stringify(this.state.sensorbox))}})

    } 

    async showSaveConfirmationModal(action? : any) {
        // note : temp solution for the org admin access to all org
        let currentPage = 0;
        
        // Sync sensorArray to sensorbox.sensors before sending the update
        if (!this.state.sensorbox) {
            Object.assign(this.state, { sensorbox: {} })
        }
        Object.assign(this.state.sensorbox, { sensors: this.sensorArray })
        
        this.setState({isLoading : true})
        await userService.updateSensorBox(this.state.sensorbox, action === 'send' ,this.props?.organisationId)
            this.setState({isLoading : false},()=>{
                if(action === 'export'){
                    this.exportConfigHandler(this.state.sensorbox)
                    this.props.updateSensorBoxList(currentPage, this.state.sensorbox?.sensor_box_name, this.state.sensorbox?.group_name)
                }else{
                    this.props.updateSensorBoxList(currentPage)
                    this.closeForm()
                }
            })
    }

    closeSaveConfirmationModal = () => {
        this.setState({ saveConfirmationModal: false , saveType : '' })
        Utility.showModal('sensorboxdetails')

    }
    convertDropdownData = (data:any, direction:string)=>{
        switch (direction){
            case 'f': return data?.map((i:any)=>({value:i._id,label:i.name}))?? []
            case 'r': return data?.map((i:any)=>({_id:i.value,name:i.label}))?? []
        }
    }

    // Maintenance Notes Methods
    fetchMaintenanceNotes = async () => {
        try {
            this.setState({ maintenanceNotesLoading: true });
            if (!this.state.sensorbox?._id || !this.state.sensorbox?.sensor_box_name) {
                this.setState({ maintenanceNotes: [], maintenanceNotesLoading: false });
                return;
            }
            
            const result = await assetMaintenanceNotesService.getMaintenanceNotes(this.state.sensorbox.sensor_box_name);
            this.setState({ maintenanceNotes: result.data || [], maintenanceNotesLoading: false });
        } catch (error: any) {
            this.setState({ maintenanceNotesLoading: false });
            toast.error(error?.response?.data?.message || 'Failed to fetch maintenance notes');
        }
    }

    handleCreateMaintenanceNote = async () => {
        try {
            if (!this.state.newNote.notes.trim()) {
                toast.error('Notes cannot be empty');
                return;
            }
            
            if (!this.state.sensorbox?.sensor_box_name) {
                toast.error('Sensor box name is required');
                return;
            }
            
            const created_on = this.state.newNote.created_on 
                ? this.state.newNote.created_on.getTime() 
                : Date.now();
            
            await assetMaintenanceNotesService.createMaintenanceNote({
                asset_id: this.state.sensorbox.sensor_box_name,
                notes: this.state.newNote.notes,
                status: this.state.newNote.status,
                created_on: created_on
            });
            
            this.setState({ newNote: { notes: '', status: 'OPEN', created_on: new Date() } });
            await this.fetchMaintenanceNotes();
            toast.success('Maintenance note created successfully');
        } catch (error: any) {
            toast.error(error?.response?.data?.message || 'Failed to create maintenance note');
        }
    }

    handleUpdateMaintenanceNote = async (noteId: string) => {
        try {
            if (!this.state.editingNote.notes.trim()) {
                toast.error('Notes cannot be empty');
                return;
            }
            
            const created_on = this.state.editingNote.created_on 
                ? this.state.editingNote.created_on.getTime() 
                : Date.now();
            
            await assetMaintenanceNotesService.updateMaintenanceNote(noteId, {
                note_id: noteId,
                notes: this.state.editingNote.notes,
                status: this.state.editingNote.status,
                created_on: created_on
            });
            
            this.setState({ editingNoteId: null, editingNote: { notes: '', status: 'OPEN', created_on: null } });
            await this.fetchMaintenanceNotes();
            toast.success('Maintenance note updated successfully');
        } catch (error: any) {
            toast.error(error?.response?.data?.message || 'Failed to update maintenance note');
        }
    }

    handleDeleteMaintenanceNote = async (noteId: string) => {
        try {
            AntModal.confirm({
                title: 'Delete Maintenance Note',
                icon: <ExclamationCircleOutlined />,
                content: 'Are you sure you want to delete this maintenance note?',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk: async () => {
                    try {
                        await assetMaintenanceNotesService.deleteMaintenanceNote(noteId);
                        await this.fetchMaintenanceNotes();
                        toast.success('Maintenance note deleted successfully');
                    } catch (error: any) {
                        toast.error(error?.response?.data?.message || 'Failed to delete maintenance note');
                    }
                }
            });
        } catch (error: any) {
            toast.error('Failed to delete maintenance note');
        }
    }

    handleStartEdit = (note: any) => {
        const createdOnDate = note.created_on 
            ? new Date(note.created_on) 
            : new Date();
        this.setState({ 
            editingNoteId: note._id,
            editingNote: { 
                notes: note.notes, 
                status: note.status,
                created_on: createdOnDate
            }
        });
    }

    handleCancelEdit = () => {
        this.setState({ editingNoteId: null, editingNote: { notes: '', status: 'OPEN', created_on: null } });
    }

    formatDateOnly = (timestamp: any) => {
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    }

    formatDate = (timestamp: any) => {
        if (!timestamp) return '-';
        return new Date(timestamp).toLocaleString();
    }

    // Insights / Tickets Methods
    fetchIssues = async () => {
        try {
            this.setState({ issuesLoading: true });
            if (!this.state.sensorbox?._id) {
                this.setState({ issues: [], issuesLoading: false });
                return;
            }
            
            const result = await issueTrackerServices.getAllIssuesBySensorboxIds([this.state.sensorbox._id], this.props?.organisationId);
            this.setState({ issues: result.issues || [], issuesLoading: false });
        } catch (error: any) {
            this.setState({ issuesLoading: false });
            toast.error(error?.response?.data?.message || 'Failed to fetch issues');
        }
    }
    render() {
        const demoCheck = (authStore?.currentUser?.active_role?.role_type === -1);
        const canViewIssues = authStore?.currentUser?.access?.includes(view_all_issue_tracker);
        const lockRouterCheck = (this.state.sensorbox?.device_type === 'lockrouter')
        const cyclicTestCheck = (this.state.sensorbox?.device_type === 'cyclictest')
        const boardVersionValue = boardVersionOptions.find((value:any)=>(value._id === this.state.sensorbox?.board_version)) 
        const deviceTypeValue = deviceTypeOptions.find((value:any)=>(value._id === this.state.sensorbox?.device_type)) 
        return (
            <div>
            <div className="modal fade bd-example-modal-lg"  id="sensorboxdetails" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg xxx">
                    <div className="modal-content">
                    <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{ this.isUpdate() ? authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? 'View Sensor Box Details' : !authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets)  ? this.state.sensorbox?.sensor_box_name : "Edit Sensor Box Details" : "Create Sensor Box Details" }</h5>
                    <span aria-hidden="true" className="close close-modal" aria-label="Close" onClick={this.closeForm}>&times;</span>
                </div>
                
                
                <div className="modal-body modal-text">
            

                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item tab-item">
    
                    <a 
                        className={this.state.tabhomeactive ? "nav-link active show":"nav-link"} 
                        id="pills-home-tab" 
                        data-toggle="pill" 
                        href="#pills-home" 
                        role="tab" 
                        aria-controls="pills-home" 
                        onClick={() => this.setState({ activeTab: 'sensorbox' })}
                        aria-selected="true"
                    >
                        Sensor Box
                    </a>
                </li>
                <li className="nav-item tab-item">
      
                    <a className={this.state.tabactive ? "nav-link active show":"nav-link"} 
                        id="pills-profile-tab" 
                        data-toggle="pill"
                        href="#pills-profile" 
                        role="tab" 
                        aria-controls="pills-profile" 
                        onClick={() => this.setState({ activeTab: 'sensors' })} 
                        aria-selected="false"
                    >
                        Sensors
                    </a>
                </li>
                {(this.isUpdate() && !demoCheck && !this.state.sensorbox?.group_name && !this.state.sensorbox?.sensorbox_group && this.state.sensorbox?.group == 0) &&
                    <li className="nav-item tab-item">
                        <a className={this.state.activeTab === 'maintenance' ? "nav-link active show":"nav-link"} 
                            id="pills-maintenance-tab" data-toggle="pill" 
                            href="#maintenance-notes" role="tab" 
                            onClick={() => {
                                this.setState({ activeTab: 'maintenance' });
                                if (this.state.maintenanceNotes.length === 0 && !this.state.maintenanceNotesLoading) {
                                    this.fetchMaintenanceNotes();
                                }
                            }}
                        >
                            Maintenance Notes
                        </a>
                    </li>
                }
                {(canViewIssues && this.isUpdate() && !demoCheck) &&
                    <li className="nav-item tab-item">
                        <a className={this.state.activeTab === 'issues' ? "nav-link active show":"nav-link"} 
                            id="pills-issues-tab" data-toggle="pill" 
                            href="#issue-tracker" role="tab" 
                            onClick={() => {
                                this.setState({ activeTab: 'issues' });
                                if (this.state.issues.length === 0 && !this.state.issuesLoading) {
                                    this.fetchIssues();
                                }
                            }}
                        >
                            Insights / Tickets
                        </a>
                    </li>
                }
                {(this.state?.sensorbox?._id) &&
                <li className="nav-item tab-item">
                    <a className={this.state.tabactive ? "nav-link active show":"nav-link"} 
                        id="pills-profile-tab" data-toggle="pill" 
                        href="#deployment-status" role="tab" 
                        onClick={() => this.setState({ activeTab: 'deployment' })}
                    >
                        Deployment Status
                    </a>
                </li>
                }
                {(this.state?.sensorbox?._id) &&
                <li className="nav-item tab-item">
                    <a className={this.state.activeTab === 'documents' ? "nav-link active show":"nav-link"}
                        id="pills-documents-tab" data-toggle="pill"
                        href="#pills-documents" role="tab"
                        onClick={() => this.setState({ activeTab: 'documents' })}
                    >
                        Documents
                    </a>
                </li>
                }

                <li className="nav-item ml-auto d-flex align-items-center" style={{ marginRight: '20px' }}>
                    <label className="custom-label mr-2 mb-0" style={{ fontSize: '0.9rem', fontWeight: 'normal' }}>Sensor Box Source:</label>
                    <div style={{ minWidth: '150px' }}>
                        <Select
                            name="sensor_box_source"
                            isDisabled={this.isDisabled()}
                            data={sensorBoxSourceOptions}
                            value={sensorBoxSourceOptions.find((value:any)=>(value._id === (this.state.sensorbox?.sensor_box_source || 'internal')))}
                            onChange={(value : any)=>this.updateSensorBoxSource(value)}
                        />
                    </div>
                </li>

                {/* {this.state.sensorbox?.sensor_box_source === 'external' && (
                    <li className="nav-item d-flex align-items-center" style={{ marginRight: '20px' }}>
                        <label className="custom-label mr-2 mb-0" style={{ fontSize: '0.9rem', fontWeight: 'normal' }}>Sensor Box Type:</label>
                        <div style={{ minWidth: '150px' }}>
                            <Select
                                name="sensor_box_type"
                                isDisabled={this.isDisabled()}
                                data={sensorBoxTypeOptions}
                                value={sensorBoxTypeOptions.find((value:any)=>(value._id === this.state.sensorbox?.sensor_box_type))}
                                onChange={(value : any)=>this.updateSensorBoxType(value)}
                            />
                        </div>
                    </li>
                )} */}

                {this.isUpdate() && !demoCheck && authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) && !authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) && this.state.activeTab !== 'maintenance' && this.state.activeTab !== 'issues' &&
                    <li className="edit-btn-positio ml-auto">                          
                        <button type="button" 
                            className="btn btn-edit" 
                            onClick={()=>this.toggleEdit()}>
                            {this.state.isEdit ? "Cancel Edit" : "Edit"}
                        </button>    
                    </li>
                } 
                </ul> 
        <div className="tab-content" id="pills-tabContent">
 
            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                {this.state.sensorbox?.sensor_box_source === 'external' ? (
                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label">Sensor Box Type <span className="mand-star">*</span></label>
                                <Select
                                    name="sensor_box_type"
                                    isDisabled={this.isDisabled()}
                                    data={sensorBoxTypeOptions}
                                    value={sensorBoxTypeOptions.find((value:any)=>(value._id === this.state.sensorbox?.sensor_box_type))}
                                    onChange={(value : any)=>this.updateSensorBoxType(value)}
                                />
                                <div className="error-msg">{this.state.error?.sensor_box_type || ''}</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label">Source ID <span className="mand-star">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="source_id"
                                    value={this.state.sensorbox?.source_id || ''}
                                    onChange={(e)=>this.updateSourceId(e)}
                                    disabled={this.isDisabled()}
                                    placeholder="Enter source unique ID"
                                />
                                <div className="error-msg">{this.state.error?.source_id || ''}</div>
                            </div>
                        </div>
                        {/* <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label">Source Type <span className="mand-star">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="source_type"
                                    value={this.state.sensorbox?.source_type || ''}
                                    onChange={(e)=>this.updateSourceType(e)}
                                    disabled={this.isDisabled()}
                                    placeholder="Enter source type"
                                />
                                <div className="error-msg">{this.state.error?.source_type || ''}</div>
                            </div>
                        </div> */}
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label" >Sensor Box ID <span className="mand-star">*</span></label>
                                <input  type="text" className="form-control" 
                                        name="sensor_box_name" aria-describedby="emailHelp" 
                                        value={this.state.sensorbox && this.state.sensorbox.sensor_box_name ?this.state.sensorbox.sensor_box_name : ''}
                                        maxLength={20}
                                        onChange={(e)=>this.updateSystemName(e)}
                                        onBlur={(e)=>this.sensorBoxExist()}
                                        disabled={ this.isDisabledSensorBoxId()}
                                        placeholder="Enter sensor box id" />
                                <div className="error-msg">{this.state.error ? this.state.error.sensor_box_name : ''}</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label" >Sensor Box Name</label>
                                <input  type="text" className="form-control" 
                                        name="alias" aria-describedby="emailHelp" 
                                        value={this.state.sensorbox && this.state.sensorbox.alias ?this.state.sensorbox.alias : ''}
                                        maxLength={40}
                                        onChange={(e)=>this.updateAlias(e)}
                                        disabled={this.isDisabled()}
                                        placeholder="Enter sensor box name" />
                                <div className="error-msg">{this.state.error ? this.state.error.alias : ''}</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label" >Sensor Box ID <span className="mand-star">*</span></label>
                                <input  type="text" className="form-control" 
                                        name="sensor_box_name" aria-describedby="emailHelp" 
                                        value={this.state.sensorbox && this.state.sensorbox.sensor_box_name ?this.state.sensorbox.sensor_box_name : ''}
                                        maxLength={20}
                                        onChange={(e)=>this.updateSystemName(e)}
                                        onBlur={(e)=>this.sensorBoxExist()}
                                        disabled={ this.isDisabledSensorBoxId()}
                                        placeholder="Enter sensor box id" />
                                <div className="error-msg">{this.state.error ? this.state.error.sensor_box_name : ''}</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label">Board Version <span className="mand-star">*</span></label>
                                <Select name="board-version"                                     
                                             isDisabled = {this.isDisabled()}
                                             data = {boardVersionOptions} 
                                             value={boardVersionValue ? boardVersionValue : ''}  
                                             onChange={(value : any)=>this.updateBoardVersion(value)}
                                />
                                 <div className="error-msg">{this.state.error && this.state.error.board_version? this.state.error.board_version : ''}</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label" >Sensor Box Name</label>
                                <input  type="text" className="form-control" 
                                        name="alias" aria-describedby="emailHelp" 
                                        value={this.state.sensorbox && this.state.sensorbox.alias ?this.state.sensorbox.alias : ''}
                                        maxLength={40}
                                        onChange={(e)=>this.updateAlias(e)}
                                        disabled={this.isDisabled()}
                                        placeholder="Enter sensor box name" />
                                <div className="error-msg">{this.state.error ? this.state.error.alias : ''}</div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                <label className="custom-label">Device Type <span className="mand-star">*</span></label>
                                <Select name="device_type"                                     
                                            isDisabled = {this.isDisabled()}
                                            data = {deviceTypeOptions} 
                                            value={deviceTypeValue ? deviceTypeValue : ''}  
                                            onChange={(value : any)=>this.updateDeviceType(value)}
                                />
                                <div className="error-msg">{this.state.error && this.state.error.device_type ?  this.state.error.device_type : ''}</div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.sensorbox?.sensor_box_source !== 'external' && (
                    <>
                        <div className="row">

                        <div className="col-md-6 col-lg-3">
                               
                               <div className="form-group">
                                       <label className="custom-label" >System Model</label>
                                       <input type="text" className="form-control" id="system_model" aria-describedby="emailHelp" 
                                       name="system_model" 
                                       value={this.state.sensorbox && this.state.sensorbox.system_model ?this.state.sensorbox.system_model : ''}
                                       onChange={(e)=>this.updateModelValue(e)}
                                       disabled={this.isDisabled()}
                                       maxLength={20}
                                       placeholder="Enter system model" />
                               <div className="error-msg">{this.state.error ? this.state.error.system_model : ''}</div>
                               </div>
                              
                        </div>

                        <div className="col-md-6 col-lg-3">
                               
                               <div className="form-group">
                                       <label className="custom-label" >Nominal Cooling Capacity</label>
                                       <input type="text" className="form-control" id="nominal_cooling_capacity" aria-describedby="emailHelp"
                                        name="nominal_cooling_capacity" 
                                        value={this.state.sensorbox && this.state.sensorbox.nominal_cooling_capacity ?this.state.sensorbox.nominal_cooling_capacity : ''}
                                        onChange={(e)=>this.updateCapacityValue(e)}
                                        disabled={this.isDisabled()}
                                        maxLength={8}
                                       placeholder="Enter nominal cooling" />
                                        <div className="error-msg">{this.state.error && this.state.error.nominal_cooling_capacity? this.state.error.nominal_cooling_capacity : ''}</div>
                                   
                                       
                               </div>
                              
                        </div>

                        <div className="col-md-6 col-lg-3">
                               
                               <div className="form-group">
                                       <label className="custom-label" >Nominal Heating</label>
                                       <input type="text" className="form-control" id="nominal_heating" aria-describedby="emailHelp"           name="nominal_heating" 
                                       value={this.state.sensorbox && this.state.sensorbox.nominal_heating ?this.state.sensorbox.nominal_heating : ''}
                                       onChange={(e)=>this.updateCapacityValue(e)}
                                       disabled={this.isDisabled()} 
                                       maxLength={8}
                                       placeholder="Enter nominal heating" />
                                        <div className="error-msg">{this.state.error && this.state.error.nominal_heating? this.state.error.nominal_heating : ''}</div>
                                   
                               </div>
                              
                           </div>
                           
                        <div className="col-md-6 col-lg-3">
                                   
                                    <div className="form-group">
                                            <label className="custom-label" >Compressor Model</label>
                                            <input type="text" className="form-control" id="compressor_model" aria-describedby="emailHelp" name="compressor_model" 
                                            value={this.state.sensorbox && this.state.sensorbox.compressor_model ?this.state.sensorbox.compressor_model : ''}
                                            onChange={(e)=>this.updateModelValue(e)}
                                            disabled={this.isDisabled()} 
                                            maxLength={20}
                                            placeholder="Enter compressor model" />
                                             <div className="error-msg">{this.state.error && this.state.error.compressor_model? this.state.error.compressor_model : ''}</div>
                                    </div>
                                   
                            </div>
                        </div>
                        <div className="row">

                        <div className="col-md-6 col-lg-3">
                                   
                                   <div className="form-group">
                                           <label className="custom-label">Expansion Valve Model</label>
                                           <input type="text" className="form-control" id="expansion_valve_model"
                                           name="expansion_valve_model" 
                                           value={this.state.sensorbox && this.state.sensorbox.expansion_valve_model ?this.state.sensorbox.expansion_valve_model : ''}
                                           onChange={(e)=>this.updateModelValue(e)}
                                           disabled={this.isDisabled()} 
                                           maxLength={20}
                                           aria-describedby="emailHelp" placeholder="Enter expansion valve model" />
                                            <div className="error-msg">{this.state.error && this.state.error.expansion_valve_model ? this.state.error.expansion_valve_model : ''}</div>

                                   </div>
                                  
                        </div>

                        <div className="col-md-6 col-lg-3">
                                   
                                   <div className="form-group">
                                           <label className="custom-label" >Evaporator Motor Model</label>
                                           <input type="text" className="form-control" id="evaporator_motor_model" aria-describedby="emailHelp" name="evaporator_motor_model" 
                                           value={this.state.sensorbox && this.state.sensorbox.evaporator_motor_model ?this.state.sensorbox.evaporator_motor_model : ''}
                                           onChange={(e)=>this.updateModelValue(e)}
                                           disabled={this.isDisabled()} 
                                           maxLength={20}
                                           placeholder="Enter evaporator motor model" />
                                            <div className="error-msg">{this.state.error && this.state.error.evaporator_motor_model ? this.state.error.evaporator_motor_model : ''}</div>

                                   </div>
                                  
                       </div>

                        <div className="col-md-6 col-lg-3">
                                   
                                   <div className="form-group">
                                           <label className="custom-label" >Condenser Motor Model</label>
                                           <input type="text" className="form-control" id="condensor_motor_model" aria-describedby="emailHelp"
                                           name="condensor_motor_model" 
                                           value={this.state.sensorbox && this.state.sensorbox.condensor_motor_model ?this.state.sensorbox.condensor_motor_model : ''}
                                           onChange={(e)=>this.updateModelValue(e)}
                                           maxLength={20}
                                           disabled={this.isDisabled()}  placeholder="Enter condenser motor model" />
                                            <div className="error-msg">{this.state.error && this.state.error.condensor_motor_model  ? this.state.error.condensor_motor_model : ''}</div>

                                   </div>
                                  
                               </div>
                        <div className="col-md-6 col-lg-3">
                               
                                <div className="form-group">
                                        <label className="custom-label" >Airflow</label>
                                        <input type="text" className="form-control" id="airflow" aria-describedby="emailHelp" 
                                        name="airflow" 
                                        value={this.state.sensorbox && this.state.sensorbox.airflow ?this.state.sensorbox.airflow : ''}
                                        onChange={(e)=>this.updateAirflowValue(e)}
                                        maxLength={6}
                                        disabled={this.isDisabled()} placeholder="Enter airflow" />
                                           <div className="error-msg">{this.state.error && this.state.error.airflow  ? this.state.error.airflow : ''}</div>

                                </div>
                               
                            </div>
                        </div>
                        <div className="row">

                        <div className="col-md-6 col-lg-3">

                               <div className="form-group">
                                       <label className="custom-label" >Refrigerant</label>
                                         <Select name="refrigerent"
                                           isDisabled = {this.isDisabled()}
                                           data = {this.state.refrigerantList}
                                           value={this.state.sensorbox && this.state.sensorbox.refrigerent ? this.state.sensorbox.refrigerent : ''}
                                           onChange={(value : any)=>this.updateRefrigerant(value)}
                                           showClose={true}
                                           clearValue={()=>this.updateRefrigerant(null)}
                                           />
                               </div>

                        </div>

                        <div className="col-md-6 col-lg-3">
                            <div className="form-group">
                                        <label className="custom-label" >Unit Serial Number</label>
                                        <input type="text" className="form-control" id="unit_serial_number" aria-describedby="emailHelp"
                                        name="unit_serial_number"
                                        value={this.state.sensorbox && this.state.sensorbox.unit_serial_number ?this.state.sensorbox.unit_serial_number : ''}
                                        onChange={(e)=>this.updateTextFieldValue(e)}
                                        maxLength={30}
                                        disabled={this.isDisabled()} placeholder="Enter unit serial number" />
                                        <div className="error-msg">{this.state.error && this.state.error.unit_serial_number  ? this.state.error.unit_serial_number : ''}</div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="custom-label">Filter Width</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Filter width"
                                        value={this.state.sensorbox?.filter_width || ''}
                                        pattern="[0-9]{0,2}(\.[0-9]{0,2})?"
                                        onChange={this.updateFilterWidth}
                                        onBlur={(e) => this.validateFilterSize('filter_width', Number(e.target.value))}
                                        disabled={this.isDisabled()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="custom-label">Filter Length</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Filter length"
                                        value={this.state.sensorbox?.filter_length || ''}
                                        pattern="[0-9]{0,2}(\.[0-9]{0,2})?"
                                        onChange={this.updateFilterLength}
                                        onBlur={(e) => this.validateFilterSize('filter_length', Number(e.target.value))}
                                        disabled={this.isDisabled()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">

                        <div className="col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="custom-label">Filter Thickness</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Filter thickness"
                                        value={this.state.sensorbox?.filter_thickness || ''}
                                        pattern="[0-9]{0,1}(\.[0-9]{0,2})?"
                                        onChange={this.updateFilterThickness}
                                        onBlur={(e) => this.validateFilterSize('filter_thickness', Number(e.target.value))}
                                        disabled={this.isDisabled()}
                                    />
                                </div>
                        </div>

                        <div className="col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="custom-label">Filter Quantity</label>
                                    <select
                                        className="form-control"
                                        disabled={this.isDisabled()}
                                        value={this.state.sensorbox?.filter_quantity || ''}
                                        onChange={this.updateFilterQuantity}
                                    >
                                        <option value="">Select</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                    </select>
                                </div>
                            </div>
                        <div className="col-md-6 col-lg-3">
                               <div className="form-group">
                                       <label className="custom-label" >System S/N</label>
                                       <Select name="system"                                    
                                           isDisabled = {this.isDisabled()}
                                           data = {this.state.inspectionList} 
                                           value={this.inspectionValue()}  
                                           onChange={(value : any)=>this.updateInspection(value)}
                                           />
                               </div>
                        </div>
                        </div>
                    </>
                )}
                <div className="row">
                    {!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) && (
                        <div className="col-md-6 col-lg-6 mb-3">
                            <AlertRecipientsCard
                                title="Property mgmt / service provider team"
                                recipients={demoCheck && this.isUpdate() ? [] : mergeTeamRecipients(
                                    this.state.sensorbox?.contractor,
                                    this.state.sensorbox?.mobile_contractor,
                                    this.state.sensorbox?.voice_contractor
                                )}
                                availableUsers={this.state.contractorList as Array<{ _id: string; name: string }>}
                                disabled={this.isDisabled() || this.isGrouped() || !!authStore?.currentUser?.access?.includes(view_contractor_sensorboxes_assets) || !!authStore?.currentUser?.access?.includes(view_assigned_users_sensorboxes_assets)}
                                onChange={(recipients) => this.updateContractorRecipients(recipients)}
                            />
                        </div>
                    )}
                    <div className={authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? "col-md-12 mb-3" : "col-md-6 col-lg-6 mb-3"}>
                        <AlertRecipientsCard
                            title="Consumer and team"
                            recipients={demoCheck && this.isUpdate() ? [] : mergeTeamRecipients(
                                this.state.sensorbox?.consumer,
                                this.state.sensorbox?.mobile_consumer,
                                this.state.sensorbox?.voice_consumer
                            )}
                            availableUsers={this.state.consumerList as Array<{ _id: string; name: string }>}
                            disabled={this.isDisabled() || this.isGrouped()}
                            onChange={(recipients) => this.updateConsumerRecipients(recipients)}
                        />
                    </div>
                </div>

                {!(this.isGrouped()) && !authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label className="custom-label">User Access</label>
                            <Select
                                isMulti
                                name="consumer"
                                isDisabled={this.isDisabled() || this.isGrouped()}
                                data={this.customerDatas(this.state.consumerList)}
                                value={this.isGrouped() ? '' : this.state.sensorbox?.userAccessObject}
                                onChange={(e:any)=>this.handleUserAccessSelection(e)}
                                userAccess={true}
                                maxOptions={15}
                            />
                        </div>
                    </div>
                </div>
                }

                <div className="row">
                <div className="col-md-6 col-lg-3">
                               
                               <div className="form-group">
                                       <label className="custom-label" >Address <span className="mand-star">*</span></label>
                                       <textarea className="form-control resize-none" id="place" aria-describedby="emailHelp" 
                                       name="place" 
                                       value={demoCheck && this.isUpdate()  ? '-': this.state.sensorbox && this.state.sensorbox.place?this.state.sensorbox.place : ''}
                                       onChange={(e)=>this.updateAddressValue(e)}
                                       onBlur={(e)=>this.coordinates()}
                                       maxLength={100}
                                       disabled={this.isDisabled()}
                                       placeholder="Enter place" ></textarea>
                                       <div className="error-msg">{this.state.error ? this.state.error.place : ''}</div>
                               </div>
                              
                </div>

                <div className="col-md-6 col-lg-3">
                       
                       <div className="form-group">
                               <label className="custom-label" >Latitude</label>
                               <input type="text" className="form-control" id="latitude" aria-describedby="emailHelp" 
                               name="latitude"    
                               value={demoCheck && this.isUpdate() ? '-' : this.state.sensorbox && this.state.sensorbox.location && this.state.sensorbox.location.coordinates && this.state.sensorbox.location.coordinates[0]? this.state.sensorbox.location.coordinates[0] : ''}
                               onChange={(e)=>this.updateLatitude(e)} 
                               disabled={true} 
                               maxLength={20}
                               placeholder="Enter latitude" />
                               <div className="error-msg">{this.state.error && this.state.error.location? this.state.error.location : ''}</div>
                       </div>
                      
                </div>

                <div className="col-md-6 col-lg-3">
                       
                       <div className="form-group">
                               <label className="custom-label" >Longitude</label>
                               <input type="text" className="form-control" id="longitude" aria-describedby="emailHelp" 
                               name="longitude" 
                               // value={this.state.sensorbox && this.state.sensorbox.longitude ?this.state.sensorbox.longitude : ''}
                               value={demoCheck && this.isUpdate() ?  '-' :  this.state.sensorbox && this.state.sensorbox.location && this.state.sensorbox.location.coordinates && this.state.sensorbox.location.coordinates[1]? this.state.sensorbox.location.coordinates[1] : ''}
                               onChange={(e)=>this.updateLongitude(e)}                                                   
                               disabled={true} 
                               placeholder="Enter longitude" />
                               
                               <div className="error-msg">{this.state.error && this.state.error.location ? this.state.error.location: ''}</div>
                               {/* <div className="error-msg">{this.state.error && this.state.error.location? this.state.error.location.coordinates[1] : ''}</div> */}
                       </div>
                      
                </div>

                <div className="col-md-6 col-lg-3">
                       
                     
                       <div className="form-group">
                                   <label className="custom-label" >Time Zone</label>
                                   <input type="text" className="form-control"
                                       name="timezone" 
                                       value={this.state.sensorbox && this.state.sensorbox.timezone ? this.state.sensorbox.timezone : ''}                                               
                                       disabled={true} 
                                       placeholder="Enter time zone" />
                                   <div className="error-msg">{this.state.error && this.state.error.location? this.state.error.timezone : ''}</div>
                        </div>
                             
                </div>
             
                </div>

                <div className="row">
                <div className="col-md-6 col-lg-3">
                       
                     
                       <div className="form-group">
                                   <label className="custom-label" >Weather Station</label>
                                   <input type="text" className="form-control"
                                       name="weather_station" 
                                       value={this.state.sensorbox && this.state.sensorbox.weather_station ? this.state.sensorbox.weather_station : 'No Station'}                                               
                                       disabled={true} 
                                       placeholder="Enter weather  station" />
                               </div>
                </div>
                <div className="col-md-6 col-lg-3">
                       
                       <div className="form-group">
                               <label className="custom-label" >Category <span className="mand-star">*</span></label>
                                <Select name="category"                                      
                                         isDisabled = {this.isDisabled() || (this.state.sensorbox?.sensor_box_source !== 'external' && !(this.state.sensorbox?.device_type === 'general'))}
                                         data = {categoryOptions} 
                                         value={this.state.sensorbox && this.state.sensorbox.category ? this.state.sensorbox?.category : ''}  
                                         onChange={(value : any)=>this.updateCategory(value)}
                                         showClose={true}
                                         clearValue={()=>this.updateCategory(null)}
                                />
                               <div className="error-msg">{this.state.error && this.state.error.category? this.state.error.category : ''}</div>
                       </div>
                     
                </div>

                    <div className="col-md-6 col-lg-3">
                       
                       <div className="form-group">
                               <label className="custom-label" >Read Interval</label>                                
                               <input type='number' min={1} disabled={this.isDisabled()} className="form-control resize-none" id="read_interval" name="read_interval"  maxLength={150} placeholder="Read Interval (default=15)" 
                                value={this.state.sensorbox?.read_interval?? '' }
                               onChange={(e)=>this.updateReadInterval(e)}  ></input>
                               <div className="error-msg">{this.state?.error?.read_interval?? ''}</div>
                           
                       </div>
                      
                    </div>
                    <div className="col-md-6 col-lg-3">
                       <div className="form-group">
                               <label className="custom-label">Offline check duration (min)</label>
                               <input
                                   type="number"
                                   min={1}
                                   step={1}
                                   disabled={this.isDisabled()}
                                   className="form-control resize-none"
                                   id="offline_check_duration"
                                   name="offline_check_duration"
                                   placeholder="Blank uses system default"
                                   value={this.state.sensorbox?.offline_check_duration ?? ''}
                                   onChange={this.updateOfflineCheckDuration}
                               />
                               <div className="error-msg">{this.state.error?.offline_check_duration || ''}</div>
                       </div>
                    </div>
                    <div className="col-md-6">
                       <div className="form-group">
                               <label className="custom-label" >Notes</label>
                               <textarea  disabled={this.isDisabled()} className="form-control resize-none" id="notes" name="notes"  maxLength={150} placeholder="Enter notes (Max 150 characters)"
                                value={this.state.sensorbox && this.state.sensorbox.notes? this.state.sensorbox.notes : '' }
                               onChange={(e)=>this.updateTextFieldValue(e)}  ></textarea>
                               <div className="error-msg">{this.state.error && this.state.error.notes? this.state.error.notes : ''}</div>
                       </div>
                    </div>
                    <div className="col-md-6">
                       <div className="form-group">
                               <label className="custom-label" htmlFor="loc_details">Location details <Tooltip title="This info will be used in alert email" trigger={['hover', 'click']}><InfoCircleOutlined style={{ marginLeft: 4, color: '#8c8c8c', fontSize: 13, cursor: 'help' }} onClick={(e) => e.preventDefault()} /></Tooltip></label>
                               <input type="text" disabled={this.isDisabled()} className="form-control" id="loc_details" name="loc_details" maxLength={150} placeholder="Enter location details (Max 150 characters)"
                                value={this.state.sensorbox?.loc_details || ''}
                               onChange={(e)=>this.updateTextFieldValue(e)} />
                               <div className="error-msg">{this.state.error && this.state.error.loc_details? this.state.error.loc_details : ''}</div>
                       </div>
                    </div>

                </div>
                            
                {this.state.sensorbox?.sensor_box_source !== 'external' && (
                    <>
                        <div className="mb-3">
                            <label className="custom-label" htmlFor="">Heating provided by: <span className="mand-star">*</span> </label>
                            <div className="d-flex">
                                <div className="form-inline px-3">
                                    <input
                                        id="heat_provided_by_furnace"
                                        type="radio"
                                        className="mr-3"
                                        name="heat_provided_by"
                                        value="furnace"
                                        checked={this.state.sensorbox?.heat_provided_by === 'furnace'}
                                        disabled={this.isDisabled()}
                                        onChange={this.updateFields}
                                    />
                                    <label htmlFor="heat_provided_by_furnace" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                        Furnace
                                    </label>
                                </div>
                                <div className="form-inline px-3">
                                    <input
                                        id="heat_provided_by_heat_pump"
                                        type="radio"
                                        className="mr-3"
                                        name="heat_provided_by"
                                        value="heat-pump"
                                        checked={this.state.sensorbox?.heat_provided_by === 'heat-pump'}
                                        disabled={this.isDisabled()}
                                        onChange={this.updateFields}
                                    />
                                    <label htmlFor="heat_provided_by_heat_pump" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                        Heat pump
                                    </label>
                                </div>
                            </div>
                            {  this.state.error?.heat_provided_by &&
                            <div className="error-msg mt-2">{this.state.error ? this.state.error.heat_provided_by : ''}</div>
                            } 
                        </div>
                        {
                            this.state.sensorbox?.heat_provided_by === 'heat-pump' &&
                            <div className="mb-3">
                                <label className="custom-label" htmlFor="">Reverse valve energized in <span className="mand-star">*</span> </label>
                                <div className="d-flex">
                                    <div className="form-inline px-3">
                                        <input
                                            id="rv_mode_heating"
                                            type="radio"
                                            className="mr-3"
                                            name="rv_mode"
                                            value="heating"
                                            checked={this.state.sensorbox?.rv_mode === 'heating'}
                                            disabled={this.isDisabled()}
                                            onChange={this.updateFields}
                                        />
                                        <label htmlFor="rv_mode_heating" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                            Heating
                                        </label>
                                    </div>
                                    <div className="form-inline">
                                        <input
                                            id="rv_mode_cooling"
                                            type="radio"
                                            className="mr-3"
                                            name="rv_mode"
                                            value="cooling"
                                            checked={this.state.sensorbox?.rv_mode === 'cooling'}
                                            disabled={this.isDisabled()}
                                            onChange={this.updateFields}
                                        />
                                        <label htmlFor="rv_mode_cooling" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                            Cooling
                                        </label>
                                    </div>
                                </div>
                                { this.state.error?.rv_mode &&
                                <div className="error-msg mt-2">{this.state.error ? this.state.error.rv_mode : ''}</div>
                                }
                            </div>
                        }

                        {
                        <div className="mb-3">
                            <label className="custom-label" htmlFor="">R Switch Condition </label>
                            <div className="d-flex">
                                <div className="form-inline px-3">
                                    <input
                                        id="r_switch_normal"
                                        type="radio"
                                        className="mr-3"
                                        name="r_switch_condition"
                                        value="normal"
                                        checked={this.state.sensorbox?.r_switch_condition === 'normal'}
                                        disabled={this.isDisabled()}
                                        onChange={this.updateFields}
                                    />
                                    <label htmlFor="r_switch_normal" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                       {`Always (24 x 7)`} 
                                    </label>
                                </div>
                                <div className="form-inline px-3">
                                    <input
                                        id="r_switch_timeframe"
                                        type="radio"
                                        className="mr-3"
                                        name="r_switch_condition"
                                        value="timeframe"
                                        checked={this.state.sensorbox?.r_switch_condition === 'timeframe'}
                                        disabled={this.isDisabled()}
                                        onChange={this.updateFields}
                                    />
                                    <label htmlFor="r_switch_timeframe" className="custom-label" style={{ fontSize: '0.85rem' }}>
                                        {`Business Hours (09 AM to 05 PM, Monday to Friday)`}
                                    </label>
                                </div>
                            </div>
                        </div>
                        }
                    </>
                )}


                <div className="row" style={{paddingBottom: "18px", paddingTop: "8px"}}>
                    <div className="col-md-6">
                        <div className="form-inline" style={{width: "max-content"}}>
                            <input 
                                type="checkbox"
                                className="mr-3"
                                checked={this.state.sensorbox?.contractor_alert_on || false}
                                disabled={this.isDisabled()}
                                onChange={this.updateContractorAlert}
                            />
                            <label className="custom-label" style={{ fontSize: '1rem' }}>
                                Enable alert for prop mgmt/service provider
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-inline">
                            <input 
                                type="checkbox"
                                className="mr-3"
                                checked={this.state.sensorbox?.consumer_alert_on || false}
                                disabled={this.isDisabled()}
                                onChange={this.updateConsumerAlert}
                            />
                            <label className="custom-label" style={{ fontSize: '1rem' }}>
                                Enable alert for consumer
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-inline" style={{width: "max-content"}}>
                            <input 
                                type="checkbox"
                                className="mr-3"
                                checked={this.state.sensorbox?.offline_alert_on || false}
                                disabled={this.isDisabled()}
                                onChange={this.updateOfflineAlert}
                            />
                            <label className="custom-label" style={{ fontSize: '1rem' }}>
                                Enable alert when device is offline / online
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            
            <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
       
                <div className="error-msg">{this.state.error && this.state.error.sensors? this.state.error.sensors : ''}</div>
                 
                {this.state.sensorbox?.sensor_box_source === 'external' ? (
                    <ExternalSensorConfig
                        name="sensor_type"
                        isDisabled={this.isDisabled()}
                        data={this.state.sensorTypeList}
                        sensor_name={this.state.sensorbox && this.state.sensorbox.sensor_box_name? this.state.sensorbox.sensor_box_name : ''} 
                        value={this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors  : []}   
                        onChange={(e:any,value : any)=>{this.updateSensorType(e,value)}}
                        errors={this.state.pinError}
                        onChangeTemplate={(value : any)=>{this.updateTemplateForBoardVersion(value)}}
                        sensorBox={this.state.sensorbox}
                        onDataChange={(minVal: any, maxVal : any, sensor_type: any, ml_accepted: boolean)=>{this.updateSensorData(minVal, maxVal, sensor_type, ml_accepted)}}
                        pinConfig={this.state.pinConfigList}
                        updatePinType={this.updatePinTypeExternal}
                        updatePinRepresentation={this.updatePinRepresentationExternal}
                        onIduCountChange={(iduCount: number) => {
                            if (!this.state.sensorbox) {
                                Object.assign(this.state, { sensorbox: {} });
                            }
                            Object.assign(this.state.sensorbox, { idu_count: iduCount });
                            this.setState({ sensorbox: this.state.sensorbox }, () => {
                                // Re-expand sensor types when idu_count changes for LGMV
                                this.reExpandLgmvSensorTypes(iduCount);
                            });
                        }}
                    />
                ) : (
                    <Checkbox  name="sensor_type"
                        isDisabled = {this.isDisabled()}
                        data = {this.state.sensorTypeList}
                        pinConfig={this.state.pinConfigList}
                        sensor_name = {this.state.sensorbox && this.state.sensorbox.sensor_box_name? this.state.sensorbox.sensor_box_name : ''} 
                        value={this.state.sensorbox && this.state.sensorbox.sensors ? this.state.sensorbox.sensors  : []}   
                        onChange={(e:any,value : any)=>{this.updateSensorType(e,value)}}
                        updatePinType={this.updatePinType}
                        updatePinRepresentation={this.updatePinRepresentation}
                        errors={this.state.pinError}
                        onChangeTemplate={(value : any)=>{this.updateTemplateForBoardVersion(value)}}
                        isLegacy={this.state.sensorbox?.version === 1}
                        boardVersion={this.state.sensorbox?.board_version}
                        sensorBox = {this.state.sensorbox}
                        selectAll={this.selectAll}
                        deselectAll={this.deselectAll}
                        sensorTemplates = {this.state.sensorTemplates}
                        clickPinNumberOnBoardImage = {(checked:any,value : any)=>{this.clickPinNumberOnBoard(checked,value)}}
                        onDataChange={(minVal: any, maxVal : any, sensor_type: any, ml_accepted: boolean)=>{this.updateSensorData(minVal, maxVal, sensor_type, ml_accepted)}}
                    />
                )}
                         
            </div>
            {(!this.state.sensorbox?.group_name && !this.state.sensorbox?.sensorbox_group && this.state.sensorbox?.group == 0) &&
            <div className={`tab-pane fade ${this.state.activeTab === 'maintenance' ? 'show active' : ''}`} id="maintenance-notes" role="tabpanel">
                {this.state.maintenanceNotesLoading ? (
                    <LoadingWheel />
                ) : (
                    <div className="table-responsive">
                        <table className="table" style={{ tableLayout: 'fixed', width: '100%' }}>
                            <colgroup>
                                <col style={{ width: '17%' }} />
                                <col style={{ width: '60%' }} />
                                <col style={{ width: '11%' }} />
                                <col style={{ width: '12%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Created Date</th>
                                    <th>Notes</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Add new note row */}
                                <tr>
                                        <td>
                                            <DatePicker
                                                placeholderText="Select date"
                                                value={this.state.newNote.created_on}
                                                dateFormat="MM/dd/yyyy"
                                                maxDate={new Date()}
                                                isClearable={true}
                                                onChange={(value: any) => {
                                                    this.setState({ newNote: { ...this.state.newNote, created_on: value } });
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Enter new note..."
                                                value={this.state.newNote.notes}
                                                onChange={(e) => this.setState({ newNote: { ...this.state.newNote, notes: e.target.value } })}
                                                onKeyPress={(e: any) => {
                                                    if (e.key === 'Enter') {
                                                        this.handleCreateMaintenanceNote();
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <select
                                                className="form-control form-control-sm"
                                                value={this.state.newNote.status}
                                                onChange={(e) => this.setState({ newNote: { ...this.state.newNote, status: e.target.value } })}
                                            >
                                                <option value="OPEN">OPEN</option>
                                                <option value="IN_PROGRESS">IN_PROGRESS</option>
                                                <option value="COMPLETED">COMPLETED</option>
                                            </select>
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={this.handleCreateMaintenanceNote}
                                                disabled={!this.state.newNote.notes.trim()}
                                            >
                                                Add
                                            </button>
                                        </td>
                                    </tr>
                                {/* Existing notes */}
                                {this.state.maintenanceNotes.map((note: any, index: number) => (
                                    <tr key={note._id || index}>
                                        <td>
                                            {this.state.editingNoteId === note._id ? (
                                                <DatePicker
                                                    placeholderText="Select date"
                                                    value={this.state.editingNote.created_on}
                                                    dateFormat="MM/dd/yyyy"
                                                    maxDate={new Date()}
                                                    isClearable={true}
                                                    onChange={(value: any) => {
                                                        this.setState({ editingNote: { ...this.state.editingNote, created_on: value || new Date() } });
                                                    }}
                                                />
                                            ) : (
                                                this.formatDateOnly(note.created_on)
                                            )}
                                        </td>
                                        <td>
                                            {this.state.editingNoteId === note._id ? (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={this.state.editingNote.notes}
                                                    onChange={(e) => this.setState({ editingNote: { ...this.state.editingNote, notes: e.target.value } })}
                                                />
                                            ) : (
                                                <span style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{note.notes}</span>
                                            )}
                                        </td>
                                        <td>
                                            {this.state.editingNoteId === note._id ? (
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={this.state.editingNote.status}
                                                    onChange={(e) => this.setState({ editingNote: { ...this.state.editingNote, status: e.target.value } })}
                                                >
                                                    <option value="OPEN">OPEN</option>
                                                    <option value="IN_PROGRESS">IN_PROGRESS</option>
                                                    <option value="COMPLETED">COMPLETED</option>
                                                </select>
                                            ) : (
                                                <span>{note.status}</span>
                                            )}
                                        </td>
                                        <td>
                                            {this.state.editingNoteId === note._id ? (
                                                <div className="d-flex" style={{ gap: '12px'}}>
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        onClick={() => this.handleUpdateMaintenanceNote(note._id)}
                                                    >
                                                        <SaveOutlined />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-secondary"
                                                        onClick={this.handleCancelEdit}
                                                    >
                                                        <CloseOutlined />
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="d-flex" style={{ gap: '12px'}}>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => this.handleStartEdit(note)}
                                                    >
                                                        <EditOutlined />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => this.handleDeleteMaintenanceNote(note._id)}
                                                    >
                                                        <DeleteOutlined />
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                {this.state.maintenanceNotes.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className="text-center py-5">
                                            <p className="text-muted">No maintenance notes found</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            }
            {canViewIssues &&
                <div className={`tab-pane fade ${this.state.activeTab === 'issues' ? 'show active' : ''}`} id="issue-tracker" role="tabpanel">
                {this.state.issuesLoading ? (
                    <LoadingWheel />
                ) : this.state.issues.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Ticket ID</th>
                                    <th>Title</th>
                                    <th>Status</th>
                                    <th>Priority</th>
                                    <th>Created On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.issues.map((issue: any, index: number) => {
                                    const issueId = issue.issue_id || '-';
                                    const handleTicketClick = () => {
                                        let params = `?ticket_id=${issue._id || issue.issue_id}`;
                                        if (authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) {
                                            params += `&org_id=${this.props?.organisationId || ''}`;
                                        }
                                        window.location.href = `${Routes.issuetrackerdetails}${params}`;
                                    };
                                    
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {issueId !== '-' ? (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleTicketClick();
                                                        }}
                                                        style={{ color: '#1890ff', textDecoration: 'underline', cursor: 'pointer' }}
                                                    >
                                                        {issueId}
                                                    </a>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                            <td>{issue.issue_title || '-'}</td>
                                            <td><span>{issue.status || '-'}</span></td>
                                            <td>{issue.issue_priority || '-'}</td>
                                            <td>{this.formatDate(issue.created_on || issue.timestamp)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <p className="text-muted">No issues found for this sensorbox</p>
                    </div>
                )}
            </div>
            }
            
            <div className="tab-pane fade" id="deployment-status" role="tabpanel">
                <DeploymentStatus
                    sensorbox={this.state?.sensorbox}
                    onChangeDeploymentStatus={(date: any , type: any , action : any) => this.onChangeDeploymentStatus(date , type, action )}
                    disabled={this.isDisabled() || demoCheck}
                />
            </div>

            {(this.state?.sensorbox?._id) &&
            <div className={`tab-pane fade ${this.state.activeTab === 'documents' ? 'show active' : ''}`} id="pills-documents" role="tabpanel">
                <DocumentsPanel
                    entityId={this.state.sensorbox._id}
                    api={sensorboxDocumentationService}
                    disabled={!authStore?.isOrgAdmin() || demoCheck}
                    emptyModelLabel="No model images added yet for this component."
                />
            </div>
            }

        </div>


                </div>
                
                <div style={{color : 'red'}}>{this.state.responseError}</div>
                <div className="modal-footer d-flex-wrap">
                    <div>
                    {(this.state.sensorbox && this.state.sensorbox._id) && this.state.isEdit && authStore?.currentUser?.access?.includes(delete_sensorboxes_assets) &&  this.state.activeTab !== 'maintenance' && this.state.activeTab !== 'issues' && this.state.activeTab !== 'documents' &&
                            <button
                                type="button"
                                className="btn btn-rounded btn-icon"
                                onClick={e => this.state.sensorbox && this.state.sensorbox.is_deleted ? this.enableSensorbox() : this.showDeleteConfirm()}
                                >
                                {this.state.sensorbox.is_deleted ?
                                    <img src={trashRestore} className="trash-restore-icon" alt=''/>
                                    :    <i className="fa fa-trash-o fa-lg" />
                                }
                            </button>
                    }
                    {
                        this.state.sensorbox?._id && authStore?.currentUser?.active_role?.role_type === 0 && this.state.isEdit  && (this.state.activeTab === 'sensorbox' ) &&
                        <button type="button" disabled={this.isDisabled() || demoCheck} className="btn btn-dark-blue ml-3" onClick={()=> this.moveSensorBox()}>Move Sensorbox</button>
                    }
                    </div>
                    <div className="error-msg">{this.state.validRangeError ? this.state.validRangeError : ''}</div>
                    <div className="error-msg">{this.state.validCalibrationError ? this.state.validCalibrationError : ''}</div>
                  {
                      this.state.activeTab !== 'maintenance' && this.state.activeTab !== 'issues' && !authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) &&
                        <div className="ml-auto">

                            {
                                (this.state.sensorbox?.version >= 3 || !this.state.sensorbox?._id) && (this.state.activeTab === 'sensors' || (this.state.activeTab === 'sensorbox' && this.state.readIntervalChanged) ) && !lockRouterCheck && !cyclicTestCheck &&
                                <>
                                    <button type="button" disabled={(this.isDisabled() || !this.sensorArray.length || !this.state.sensorbox?.sensor_box_name || demoCheck || lockRouterCheck || cyclicTestCheck)} className="btn btn-dark-blue mr-3" onClick={()=> this.saveSensors('export')}>Save & Export</button>
                                    {this.state.sensorbox?.sensor_box_source !== 'external' &&
                                        <button type="button" disabled={this.isDisabled() || !this.sensorArray.length ||  this.state.sensorbox?.device_config_status === 2 || demoCheck || lockRouterCheck || cyclicTestCheck} className="btn btn-dark-blue mr-3" onClick={()=>this.saveSensors('send')}>Save & Send</button>
                                    }
                                </>
                            }
                            <button type="button" disabled={this.isDisabled() || demoCheck} className="btn btn-dark-blue" onClick={()=>this.saveSensors()}>Save</button>
                        </div>
                  }
              
                </div>

                    </div>
                </div>
                <div>
                    {this.state.isLoading ?
                    <LoadingWheel/>
                    :   null}
                </div>
            </div>
            
            <SaveConfirmationModal
                title={`Edit sensorbox details`}
                message={`Are you sure want to make changes to the sensorbox ${this.state.sensorbox?.sensor_box_name} `}
                visible = {this.state.saveConfirmationModal}
                confirm ={"YES"}
                action={() => (this.showSaveConfirmationModal(this.state?.saveType))}
                toggleVisibility={this.closeSaveConfirmationModal}
            />

            <ConfirmModal
                title="Delete sensor box"
                message={`${this.state.issueCount > 0 ? constants.message.deleteSensorboxWarning : this.isGrouped() ? `This sensor box is part of ${this.props?.sensorbox?.group_name}.
                Deleting this will also remove from the ${this.props?.sensorbox?.group_name}. Do you want to continue ?`
                : 'Do you want to delete the sensor box ?'}`}
                closeConfirmModal={this.closeConfirmModal}
                delete={this.deleteSensorbox}
                isLoading = {this.state.isLoading}
                isSuperAdmin = {authStore?.currentUser?.active_role?.role_type === 0 ? true : false}
            />
            <MoveSensorboxModal
               show={this.state.showMoveSensorboxModal}
               onClose={this.closeMoveSensorsModal}
               sensorBoxDetails={this.state.sensorbox}
               organisationList={this.props.organisationList}
               closeModal ={(orgName: any) => this.closeMoveSensorboxModal(orgName)}
               isLoading = {this.state.isLoading}
            />
            { this.state.roleList.length > 1 &&
            <UserModal checkSensor={true} updateCustomerList={this.getCustomerList} roleList ={this.state.roleList} organisationId={this.props?.organisationId ? this.props?.organisationId : authStore?.currentUser?.oid}/>
            }
              

        </div>




        );
    }
}
 
export default CreateSensorBox;